let browseSvg = 
  `
    <svg viewBox="0 0 65 61" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M56.6255 36.4754V42.4313C56.6255 42.7666 56.5188 43.0754 56.3677 43.349C56.3588 43.3754 56.3677 43.3931 56.3588 43.4196C56.3144 43.4901 56.2433 43.5343 56.1988 43.6049C56.1188 43.7196 56.0299 43.8166 55.9233 43.9137C55.8255 44.0019 55.7188 44.0637 55.6122 44.1254C55.5055 44.1872 55.3988 44.249 55.2744 44.2931C55.1411 44.3372 55.0077 44.3549 54.8744 44.3725C54.7944 44.3813 54.7144 44.4166 54.6344 44.4166C54.5899 44.4166 54.5544 44.399 54.5188 44.3901C54.3855 44.3813 54.2611 44.346 54.1277 44.3107C53.9944 44.2754 53.8699 44.2401 53.7544 44.1872C53.7188 44.1696 53.6744 44.1696 53.6388 44.1519L40.2522 36.4843H28.6433C24.2255 36.4843 20.6522 32.9284 20.6522 28.5519V8.69896C20.6522 4.31366 24.2344 0.766602 28.6433 0.766602H56.6255C61.0433 0.766602 64.6166 4.32249 64.6166 8.69896V28.5431C64.6166 32.9284 61.0433 36.4754 56.6255 36.4754ZM60.6255 8.69896C60.6255 6.51072 58.8388 4.72837 56.6255 4.72837H28.6433C26.4388 4.72837 24.6433 6.5019 24.6433 8.69896V28.5431C24.6433 30.7313 26.4299 32.5137 28.6433 32.5137H40.8744L40.9099 32.5401C41.2033 32.5578 41.4966 32.6284 41.7722 32.7872L52.6255 39.0078V34.5078C52.6255 33.4137 53.5233 32.5225 54.6255 32.5225H56.6255C58.8299 32.5225 60.6255 30.749 60.6255 28.5519V8.69896ZM54.6255 20.6107C53.5233 20.6107 52.6255 19.7195 52.6255 18.6254C52.6255 17.5313 53.5233 16.6401 54.6255 16.6401C55.7277 16.6401 56.6255 17.5313 56.6255 18.6254C56.6255 19.7195 55.7277 20.6107 54.6255 20.6107ZM42.6344 20.6107C41.5322 20.6107 40.6344 19.7195 40.6344 18.6254C40.6344 17.5313 41.5322 16.6401 42.6344 16.6401C43.7366 16.6401 44.6344 17.5313 44.6344 18.6254C44.6344 19.7195 43.7366 20.6107 42.6344 20.6107ZM30.6433 20.6107C29.541 20.6107 28.6433 19.7195 28.6433 18.6254C28.6433 17.5313 29.541 16.6401 30.6433 16.6401C31.7455 16.6401 32.6433 17.5313 32.6433 18.6254C32.6433 19.7195 31.7455 20.6107 30.6433 20.6107ZM4.66103 24.5725V44.4166C4.66103 46.6049 6.4477 48.3872 8.66104 48.3872H10.661C11.7633 48.3872 12.661 49.2784 12.661 50.3725V54.8725L23.5055 48.6519C23.781 48.4931 24.0744 48.4313 24.3677 48.4049L24.4033 48.3784H36.6344C38.8388 48.3784 40.6344 46.6049 40.6344 44.4078H44.6344C44.6344 48.7931 41.0522 52.3401 36.6433 52.3401H25.0344L11.6477 60.0078C11.6121 60.0254 11.5677 60.0254 11.5321 60.0431C11.4166 60.1049 11.2833 60.1313 11.1588 60.1666C11.0255 60.2019 10.901 60.2372 10.7677 60.246C10.7233 60.246 10.6877 60.2725 10.6521 60.2725C10.5633 60.2725 10.4921 60.2372 10.4121 60.2284C10.2699 60.2107 10.1455 60.1931 10.0121 60.149C9.8877 60.1049 9.78104 60.0519 9.67437 59.9813C9.5677 59.9196 9.46104 59.8578 9.36326 59.7696C9.25659 59.6813 9.17659 59.5754 9.0877 59.4607C9.03437 59.3901 8.96326 59.346 8.9277 59.2754C8.91881 59.249 8.9277 59.2313 8.91881 59.2049C8.7677 58.9225 8.66104 58.6225 8.66104 58.2872V52.3313C4.24326 52.3313 0.669922 48.7754 0.669922 44.399V24.5725C0.669922 20.1872 4.25214 16.6401 8.66104 16.6401H16.6521V20.6107H8.66104C6.4477 20.6107 4.66103 22.3843 4.66103 24.5725Z" fill="#3C3C3C"></path></svg>
  `
  
  let giveSvg = 
  `
  <svg viewBox="0 0 65 61" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M56.6255 36.4754V42.4313C56.6255 42.7666 56.5188 43.0754 56.3677 43.349C56.3588 43.3754 56.3677 43.3931 56.3588 43.4196C56.3144 43.4901 56.2433 43.5343 56.1988 43.6049C56.1188 43.7196 56.0299 43.8166 55.9233 43.9137C55.8255 44.0019 55.7188 44.0637 55.6122 44.1254C55.5055 44.1872 55.3988 44.249 55.2744 44.2931C55.1411 44.3372 55.0077 44.3549 54.8744 44.3725C54.7944 44.3813 54.7144 44.4166 54.6344 44.4166C54.5899 44.4166 54.5544 44.399 54.5188 44.3901C54.3855 44.3813 54.2611 44.346 54.1277 44.3107C53.9944 44.2754 53.8699 44.2401 53.7544 44.1872C53.7188 44.1696 53.6744 44.1696 53.6388 44.1519L40.2522 36.4843H28.6433C24.2255 36.4843 20.6522 32.9284 20.6522 28.5519V8.69896C20.6522 4.31366 24.2344 0.766602 28.6433 0.766602H56.6255C61.0433 0.766602 64.6166 4.32249 64.6166 8.69896V28.5431C64.6166 32.9284 61.0433 36.4754 56.6255 36.4754ZM60.6255 8.69896C60.6255 6.51072 58.8388 4.72837 56.6255 4.72837H28.6433C26.4388 4.72837 24.6433 6.5019 24.6433 8.69896V28.5431C24.6433 30.7313 26.4299 32.5137 28.6433 32.5137H40.8744L40.9099 32.5401C41.2033 32.5578 41.4966 32.6284 41.7722 32.7872L52.6255 39.0078V34.5078C52.6255 33.4137 53.5233 32.5225 54.6255 32.5225H56.6255C58.8299 32.5225 60.6255 30.749 60.6255 28.5519V8.69896ZM54.6255 20.6107C53.5233 20.6107 52.6255 19.7195 52.6255 18.6254C52.6255 17.5313 53.5233 16.6401 54.6255 16.6401C55.7277 16.6401 56.6255 17.5313 56.6255 18.6254C56.6255 19.7195 55.7277 20.6107 54.6255 20.6107ZM42.6344 20.6107C41.5322 20.6107 40.6344 19.7195 40.6344 18.6254C40.6344 17.5313 41.5322 16.6401 42.6344 16.6401C43.7366 16.6401 44.6344 17.5313 44.6344 18.6254C44.6344 19.7195 43.7366 20.6107 42.6344 20.6107ZM30.6433 20.6107C29.541 20.6107 28.6433 19.7195 28.6433 18.6254C28.6433 17.5313 29.541 16.6401 30.6433 16.6401C31.7455 16.6401 32.6433 17.5313 32.6433 18.6254C32.6433 19.7195 31.7455 20.6107 30.6433 20.6107ZM4.66103 24.5725V44.4166C4.66103 46.6049 6.4477 48.3872 8.66104 48.3872H10.661C11.7633 48.3872 12.661 49.2784 12.661 50.3725V54.8725L23.5055 48.6519C23.781 48.4931 24.0744 48.4313 24.3677 48.4049L24.4033 48.3784H36.6344C38.8388 48.3784 40.6344 46.6049 40.6344 44.4078H44.6344C44.6344 48.7931 41.0522 52.3401 36.6433 52.3401H25.0344L11.6477 60.0078C11.6121 60.0254 11.5677 60.0254 11.5321 60.0431C11.4166 60.1049 11.2833 60.1313 11.1588 60.1666C11.0255 60.2019 10.901 60.2372 10.7677 60.246C10.7233 60.246 10.6877 60.2725 10.6521 60.2725C10.5633 60.2725 10.4921 60.2372 10.4121 60.2284C10.2699 60.2107 10.1455 60.1931 10.0121 60.149C9.8877 60.1049 9.78104 60.0519 9.67437 59.9813C9.5677 59.9196 9.46104 59.8578 9.36326 59.7696C9.25659 59.6813 9.17659 59.5754 9.0877 59.4607C9.03437 59.3901 8.96326 59.346 8.9277 59.2754C8.91881 59.249 8.9277 59.2313 8.91881 59.2049C8.7677 58.9225 8.66104 58.6225 8.66104 58.2872V52.3313C4.24326 52.3313 0.669922 48.7754 0.669922 44.399V24.5725C0.669922 20.1872 4.25214 16.6401 8.66104 16.6401H16.6521V20.6107H8.66104C6.4477 20.6107 4.66103 22.3843 4.66103 24.5725Z" fill="#3C3C3C"></path></svg>
  `

  let down_caret = 
  `
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="down-caret"><polygon points="50 77.1 2.15 28.51 7.85 22.9 50 65.7 92.15 22.9 97.85 28.51 50 77.1"></polygon></g></svg>
  `

  //FAQ下拉菜单
  let menuFaqList = [
    {
      categoryId:'Headphones',
      categoryName: 'Auriculares',
      seriesList:[
        {
          seriesId: 'X_Series',
          seriesName: 'Serie X',
          productList:[
            {
              productId: 'TOZO_Golden_X1',
              productName: 'TOZO Golden X1',
            },
          ]
        },
        {
          seriesId: 'Over_Ear_Series',
          seriesName: 'Serie Over Ear',
          productList:[
            {
              productId: 'TOZO_HT2',
              productName: 'TOZO HT2',
            },
            {
              productId: 'TOZO_H10',
              productName: 'TOZO H10',
            },
          ]
        },
        {
          seriesId: 'Open_Series',
          seriesName: 'Serie Open',
          productList:[
            {
              productId: 'TOZO_Open_Buds',
              productName: 'TOZO Open Buds',
            },
            {
              productId: 'TOZO_Open_Real',
              productName: 'TOZO OpenReal',
            },
            {
              productId: 'TOZO_Open_Ego',
              productName: 'TOZO OpenEgo',
            },
            {
              productId: 'TOZO_OpenEarRing',
              productName: 'TOZO OpenEarRing',
            }
          ]
        },
        {
          seriesId: 'T_Series',
          seriesName: 'Serie T',
          productList:[
            {
              productId: 'TOZO_T6',
              productName: 'TOZO T6',
            },
            {
              productId: 'TOZO_T6_Mini',
              productName: 'TOZO T6 Mini',
            },
            {
              productId: 'TOZO_T9',
              productName: 'TOZO T9',
            },
            {
              productId: 'TOZO_T10',
              productName: 'TOZO T10',
            },
            {
              productId: 'TOZO_T10_Mini',
              productName: 'TOZO T10 Mini',
            },
            {
              productId: 'TOZO_T12',
              productName: 'TOZO T12',
            },
            {
              productId: 'TOZO_T12_Pro',
              productName: 'TOZO T12 Pro',
            },
            {
              productId: 'TOZO_T20',
              productName: 'TOZO T20',
            },
            {
              productId: 'TOZO_T21',
              productName: 'TOZO T21',
            },
            {
              productId: 'TOZO_Crystal_Buds',
              productName: 'TOZO Crystal Buds',
            },
          ]
        },
        {
          seriesId: 'Tonal_Series',
          seriesName: 'Serie Tonal',
          productList:[
            {
              productId: 'TOZO_Tonal_Dots',
              productName: 'TOZO Tonal Dots',
            },
            {
              productId: 'TOZO_T6S',
              productName: 'TOZO T6S',
            },
            {
              productId: 'TOZO_T10S',
              productName: 'TOZO T10S',
            },
          ]
        },
        {
          seriesId: 'NC_Series',
          seriesName: 'Serie NC',
          productList:[
            {
              productId: 'TOZO_NC2',
              productName: 'TOZO NC2',
            },
            {
              productId: 'TOZO_NC3',
              productName: 'TOZO NC3',
            },
            {
              productId: 'TOZO_NC7',
              productName: 'TOZO NC7',
            },
            {
              productId: 'TOZO_NC9',
              productName: 'TOZO NC9',
            },
            {
              productId: 'TOZO_NC9_Plus',
              productName: 'TOZO NC9 Plus',
            },
            {
              productId: 'TOZO_NC20',
              productName: 'TOZO NC20',
            },
            {
              productId: ' TOZO_Cryatl_Pods',
              productName: ' TOZO Cryatl Pods',
            },
          ]
        },
        {
          seriesId: 'NC_Pro_Series',
          seriesName: 'Serie NC Pro',
          productList:[
            {
              productId: 'TOZO_NC2_Pro',
              productName: 'TOZO NC2 Pro',
            },
            {
              productId: 'TOZO_NC7_Pro',
              productName: 'TOZO NC7 Pro',
            },
            {
              productId: 'TOZO_NC9_Pro',
              productName: 'TOZO NC9 Pro',
            },
            {
              productId: 'TOZO_NC9_Pro_Max',
              productName: 'TOZO NC9 Pro Max',
            },
            {
              productId: 'TOZO_NC20_Pro',
              productName: 'TOZO NC20 Pro',
            },
          ]
        },
        {
          seriesId: 'A_Series',
          seriesName: 'Serie A',
          productList:[
            {
              productId: 'TOZO_A1',
              productName: 'TOZO A1',
            },
            {
              productId: 'TOZO_A2',
              productName: 'TOZO A2',
            },
            {
              productId: 'TOZO_A3',
              productName: 'TOZO A3',
            },
          ]
        },
        {
          seriesId: 'Agile_Series',
          seriesName: 'Serie ágil',
          productList:[
            {
              productId: 'TOZO_Agile_Pods',
              productName: 'TOZO Agile Pods',
            },
            {
              productId: 'TOZO_Agile_Dots',
              productName: 'TOZO Agile Dots',
            },
          ]
        },
        {
          seriesId: 'E_Series',
          seriesName: 'Serie E',
          productList:[
            {
              productId: 'TOZO_E1',
              productName: 'TOZO E1',
            },
            {
              productId: 'TOZO_E2',
              productName: 'TOZO E2',
            },
          ]
        },
        {
          seriesId: 'G_Series',
          seriesName: 'Serie G',
          productList:[
            {
              productId: 'TOZO_G1',
              productName: 'TOZO G1',
            },
            {
              productId: 'TOZO_Gaming_Pods',
              productName: 'TOZO Gaming Pods',
            },
          ]
        },
      ]
    },
    {
      categoryId: 'Watches',
      categoryName: 'Relojes',
      // seriesList:[
      //   {
      //     seriesId: 'Watches',
      //     seriesName: 'Relojes',
          productList:[
            {
              productId: 'TOZO_S1',
              productName: 'TOZO S1',
            },
            {
              productId: 'TOZO_S2',
              productName: 'TOZO S2',
            },
            {
              productId: 'TOZO_S3',
              productName: 'TOZO S3',
            },
            {
              productId: 'TOZO_S4',
              productName: 'TOZO S4',
            },
            {
              productId: 'TOZO_S5',
              productName: 'TOZO S5',
            },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Speakers',
      categoryName: 'Oradores',
      // seriesList:[
      //   {
      //     seriesId: 'Speakers',
      //     seriesName: 'Oradores',
          productList:[
            {
              productId: 'TOZO_PA1',
              productName: 'TOZO PA1',
            },
            {
              productId: 'TOZO_PA2',
              productName: 'TOZO PA2',
            },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Panoramic_Camera',
      categoryName: 'Cámara panorámica',
      // seriesList:[
      //   {
      //     seriesId: 'Smart_audio_and_video',
      //     seriesName: 'Audio y vídeo inteligentes',
          productList:[
            {
              productId: 'AnyVue',
              productName: 'AnyVue',
            },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Wireless_Charging',
      categoryName: 'Carga inalámbrica',
      // seriesList:[
      //   {
      //     seriesId: 'Wireless_Charger',
      //     seriesName: 'Cargador inalámbrico',
          productList:[
            {
              productId: 'TOZO_W1',
              productName: 'TOZO W1',
            },
            {
              productId: 'TOZO_WB1',
              productName: 'TOZO WB1',
            },
            {
              productId: 'TOZO_W6',
              productName: 'TOZO W6',
            },
            {
              productId: 'TOZO_W8',
              productName: 'TOZO W8',
            },
            {
              productId: 'TOZO_W10',
              productName: 'TOZO W10',
            },
        //   ]
        // }
      ]
    },
    {
      categoryId: 'Charger',
      categoryName: 'Cargador',
      seriesList:[
        {
          seriesId: 'Wall_Chargers',
          seriesName: 'Cargadores de pared',
          productList:[
            {
              productId: 'TOZO_C1',
              productName: 'TOZO C1',
            },
            {
              productId: 'TOZO_C2',
              productName: 'TOZO C2',
            },
          ]
        },
        {
          seriesId: 'Power_Banks',
          seriesName: 'Bancos de energía',
          productList:[
            {
              productId: 'TOZO_PB1',
              productName: 'TOZO PB1',
            },
            {
              productId: 'TOZO_PB2',
              productName: 'TOZO PB2',
            },
            {
              productId: 'TOZO_PB3',
              productName: 'TOZO PB3',
            },
          ]
        },
      ]
    },
  ]

  //Manuals下拉菜单
  let menuManualsList = [
    {
      categoryId:'Headphones',
      categoryName: 'Auriculares',
      seriesList:[
        {
          seriesId: 'X_Series',
          seriesName: 'Serie X',
          productList:[
            {
              productId: 'TOZO_Golden_X1',
              productName: 'TOZO Golden X1',
            },
            {
              productId: 'TOZO_Color_Pods',
              productName: 'TOZO Color Pods',
            },
          ]
        },
        {
          seriesId: 'Over_Ear_Series',
          seriesName: 'Serie Over Ear',
          productList:[
            {
              productId: 'TOZO_HA1',
              productName: 'TOZO HA1',
            },
            {
              productId: 'TOZO_HT1',
              productName: 'TOZO HT1',
            },
            {
              productId: 'TOZO_HT2',
              productName: 'TOZO HT2',
            },
            // {
            //   productId: 'TOZO_H10',
            //   productName: 'TOZO H10',
            // },
          ]
        },
        {
          seriesId: 'Open_Series',
          seriesName: 'Serie Open',
          productList:[
            {
              productId: 'TOZO_Open_X2_Pro',
              productName: 'TOZO Open X2 Pro',
            },
            {
              productId: 'TOZO_Open_Buds',
              productName: 'TOZO Open Buds',
            },
            {
              productId: 'TOZO_Open_Real',
              productName: 'TOZO OpenReal',
            },
            {
              productId: 'TOZO_Open_Ego',
              productName: 'TOZO OpenEgo',
            },
            {
              productId: 'TOZO_Open_EarRing',
              productName: 'TOZO Open EarRing',
            },
            {
              productId: 'TOZO_O2',
              productName: 'TOZO O2',
            },
            // {
            //   productId: 'TOZO_OpenWear',
            //   productName: 'TOZO OpenWear',
            // }
          ]
        },
        {
          seriesId: 'T_Series',
          seriesName: 'Serie T',
          productList:[
            {
              productId: 'TOZO_T6',
              productName: 'TOZO T6',
            },
            {
              productId: 'TOZO_T6_Mini',
              productName: 'TOZO T6 Mini',
            },
            {
              productId: 'TOZO_T9',
              productName: 'TOZO T9',
            },
            {
              productId: 'TOZO_T10',
              productName: 'TOZO T10',
            },
            {
              productId: 'TOZO_T10_Mini',
              productName: 'TOZO T10 Mini',
            },
            {
              productId: 'TOZO_T12',
              productName: 'TOZO T12',
            },
            {
              productId: 'TOZO_T12_Pro',
              productName: 'TOZO T12 Pro',
            },
            {
              productId: 'TOZO_T20',
              productName: 'TOZO T20',
            },
            {
              productId: 'TOZO_T21',
              productName: 'TOZO T21',
            },
            {
              productId: 'TOZO_Crystal_Buds',
              productName: 'TOZO Crystal Buds',
            },
          ]
        },
        {
          seriesId: 'Tonal_Series',
          seriesName: 'Serie Tonal',
          productList:[
            {
              productId: 'TOZO_Tonal_Dots',
              productName: 'TOZO Tonal Dots',
            },
            {
              productId: 'TOZO_Tonal_Fits',
              productName: 'TOZO Tonal Fits',
            },
            // {
            //   productId: 'TOZO_T6S',
            //   productName: 'TOZO T6S',
            // },
            // {
            //   productId: 'TOZO_T10S',
            //   productName: 'TOZO T10S',
            // },
          ]
        },
        {
          seriesId: 'NC_Series',
          seriesName: 'Serie NC',
          productList:[
            {
              productId: 'TOZO_NC2',
              productName: 'TOZO NC2',
            },
            {
              productId: 'TOZO_NC3',
              productName: 'TOZO NC3',
            },
            {
              productId: 'TOZO_NC7',
              productName: 'TOZO NC7',
            },
            {
              productId: 'TOZO_NC9',
              productName: 'TOZO NC9',
            },
            // {
            //   productId: 'TOZO_NC9_Plus',
            //   productName: 'TOZO NC9 Plus',
            // },
            {
              productId: 'TOZO_NC20',
              productName: 'TOZO NC20',
            },
            {
              productId: 'TOZO_NC20_Pro',
              productName: 'TOZO NC20 Pro',
            },
            {
              productId: 'TOZO_Crystal_Pods',
              productName: 'TOZO Crystal Pods',
            },
          ]
        },
        // {
        //   seriesId: 'NC_Pro_Series',
        //   seriesName: 'Serie NC Pro',
        //   productList:[
        //     {
        //       productId: 'TOZO_NC2_Pro',
        //       productName: 'TOZO NC2 Pro',
        //     },
        //     {
        //       productId: 'TOZO_NC7_Pro',
        //       productName: 'TOZO NC7 Pro',
        //     },
        //     {
        //       productId: 'TOZO_NC9_Pro',
        //       productName: 'TOZO NC9 Pro',
        //     },
        //     {
        //       productId: 'TOZO_NC9_Pro_Max',
        //       productName: 'TOZO NC9 Pro Max',
        //     },
        //   ]
        // },
        {
          seriesId: 'A_Series',
          seriesName: 'Serie A',
          productList:[
            {
              productId: 'TOZO_A1',
              productName: 'TOZO A1',
            },
            {
              productId: 'TOZO_A2',
              productName: 'TOZO A2',
            },
            {
              productId: 'TOZO_A3',
              productName: 'TOZO A3',
            },
          ]
        },
        {
          seriesId: 'E_Series',
          seriesName: 'Serie E',
          productList:[
            {
              productId: 'TOZO_E1',
              productName: 'TOZO E1',
            },
            {
              productId: 'TOZO_E2',
              productName: 'TOZO E2',
            },
          ]
        },
        // {
        //   seriesId: 'Agile_Series',
        //   seriesName: 'Serie ágil',
        //   productList:[
        //     {
        //       productId: 'TOZO_Agile_Pods',
        //       productName: 'TOZO Agile Pods',
        //     },
        //     {
        //       productId: 'TOZO_Agile_Dots',
        //       productName: 'TOZO Agile Dots',
        //     },
        //   ]
        // },
        // {
        //   seriesId: 'G_Series',
        //   seriesName: 'Serie G',
        //   productList:[
        //     {
        //       productId: 'TOZO_G1',
        //       productName: 'TOZO G1',
        //     },
        //     {
        //       productId: 'TOZO_Gaming_Pods',
        //       productName: 'TOZO Gaming Pods',
        //     },
        //   ]
        // },
      ]
    },
    {
      categoryId: 'Watches',
      categoryName: 'Relojes',
      // seriesList:[
      //   {
      //     seriesId: 'Watches',
      //     seriesName: 'Relojes',
          productList:[
            {
              productId: 'TOZO_Watch1',
              productName: 'TOZO Watch1',
            },
            // {
            //   productId: 'TOZO_S1',
            //   productName: 'TOZO S1',
            // },
            {
              productId: 'TOZO_S2',
              productName: 'TOZO S2',
            },
            // {
            //   productId: 'TOZO_S3',
            //   productName: 'TOZO S3',
            // },
            // {
            //   productId: 'TOZO_S4',
            //   productName: 'TOZO S4',
            // },
            {
              productId: 'TOZO_S5',
              productName: 'TOZO S5',
            },
            {
              productId: 'TOZO_S7',
              productName: 'TOZO S7',
            },
            {
              productId: 'TOZO_S8',
              productName: 'TOZO S8',
            },
            {
              productId: 'TOZO_AcuFit_Solo',
              productName: 'TOZO AcuFit Solo',
            },
            {
              productId: 'TOZO_AcuFit_Evo',
              productName: 'TOZO AcuFit Evo',
            },
          ]
    //     }
    //   ]
    },
    {
      categoryId: 'Speakers',
      categoryName: 'Oradores',
      // seriesList:[
      //   {
      //     seriesId: 'Speakers',
      //     seriesName: 'Speakers',
          productList:[
            {
              productId: 'TOZO_PA1',
              productName: 'TOZO PA1',
            },
            {
              productId: 'TOZO_PA2',
              productName: 'TOZO PA2',
            },
            {
              productId: 'TOZO_PE1',
              productName: 'TOZO PE1',
            },
          ]
      //   }
      // ]
    },
    // {
    //   categoryId: 'Panoramic_Camera',
    //   categoryName: 'Cámara panorámica',
    //   seriesList:[
    //     {
    //       seriesId: 'Smart_audio_and_video',
    //       seriesName: 'Audio y vídeo inteligentes',
    //       productList:[
    //         {
    //           productId: 'AnyVue',
    //           productName: 'AnyVue',
    //         },
    //       ]
    //     }
    //   ]
    // },
    {
      categoryId: 'Wireless_Charging',
      categoryName: 'Carga inalámbrica',
      // seriesList:[
      //   {
      //     seriesId: 'Wireless_Charger',
      //     seriesName: 'Cargador inalámbrico',
          productList:[
            {
              productId: 'TOZO_W1',
              productName: 'TOZO W1',
            },
            // {
            //   productId: 'TOZO_WB1',
            //   productName: 'TOZO WB1',
            // },
            {
              productId: 'TOZO_W6',
              productName: 'TOZO W6',
            },
            // {
            //   productId: 'TOZO_W8',
            //   productName: 'TOZO W8',
            // },
            {
              productId: 'TOZO_W10',
              productName: 'TOZO W10',
            },
          ]
      //   }
      // ]
    },
    // {
    //   categoryId: 'Charger',
    //   categoryName: 'Cargador',
    //   seriesList:[
    //     {
    //       seriesId: 'Wall_Chargers',
    //       seriesName: 'Cargadores de pared',
    //       productList:[
    //         {
    //           productId: 'TOZO_C1',
    //           productName: 'TOZO C1',
    //         },
    //         {
    //           productId: 'TOZO_C2',
    //           productName: 'TOZO C2',
    //         },
    //       ]
    //     },
    //     {
    //       seriesId: 'Power_Banks',
    //       seriesName: 'Bancos de energía',
    //       productList:[
    //         {
    //           productId: 'TOZO_PB1',
    //           productName: 'TOZO PB1',
    //         },
    //         {
    //           productId: 'TOZO_PB2',
    //           productName: 'TOZO PB2',
    //         },
    //         {
    //           productId: 'TOZO_PB3',
    //           productName: 'TOZO PB3',
    //         },
    //       ]
    //     },
    //   ]
    // },
  ]

  //Video下拉菜单
  let menuVideoList = [
    {
      categoryId:'Headphones',
      categoryName: 'Auriculares',
      seriesList:[
        {
          seriesId: 'X_Series',
          seriesName: 'Serie X',
          productList:[
            {
              productId: 'TOZO_Golden_X1',
              productName: 'TOZO Golden X1',
            },
          ]
        },
        {
          seriesId: 'Over_Ear_Series',
          seriesName: 'Serie Over Ear',
          productList:[
            {
              productId: 'TOZO_HT2',
              productName: 'TOZO HT2',
            },
            {
              productId: 'TOZO_H10',
              productName: 'TOZO H10',
            },
          ]
        },
        {
          seriesId: 'Open_Series',
          seriesName: 'Serie Open',
          productList:[
            {
              productId: 'TOZO_Open_Buds',
              productName: 'TOZO Open Buds',
            },
            {
              productId: 'TOZO_Open_Real',
              productName: 'TOZO OpenReal',
            },
            {
              productId: 'TOZO_Open_Ego',
              productName: 'TOZO OpenEgo',
            }
          ]
        },
        {
          seriesId: 'T_Series',
          seriesName: 'Serie T',
          productList:[
            {
              productId: 'TOZO_T6',
              productName: 'TOZO T6',
            },
            // {
            //   productId: 'TOZO_T6_Mini',
            //   productName: 'TOZO T6 Mini',
            // },
            // {
            //   productId: 'TOZO_T9',
            //   productName: 'TOZO T9',
            // },
            // {
            //   productId: 'TOZO_T10',
            //   productName: 'TOZO T10',
            // },
            // {
            //   productId: 'TOZO_T10_Mini',
            //   productName: 'TOZO T10 Mini',
            // },
            // {
            //   productId: 'TOZO_T12',
            //   productName: 'TOZO T12',
            // },
            // {
            //   productId: 'TOZO_T12_Pro',
            //   productName: 'TOZO T12 Pro',
            // },
            {
              productId: 'TOZO_T20',
              productName: 'TOZO T20',
            },
            // {
            //   productId: 'TOZO_T21',
            //   productName: 'TOZO T21',
            // },
            {
              productId: 'TOZO_Crystal_Buds',
              productName: 'TOZO Crystal Buds',
            },
          ]
        },
        {
          seriesId: 'Tonal_Series',
          seriesName: 'Serie Tonal',
          productList:[
            {
              productId: 'TOZO_Tonal_Pots',
              productName: 'TOZO Tonal Pots',
            },
            {
              productId: 'TOZO_Tonal_Fits',
              productName: 'TOZO Tonal Fits',
            },
            {
              productId: 'TOZO_T6S',
              productName: 'TOZO T6S',
            },
            {
              productId: 'TOZO_T10S',
              productName: 'TOZO T10S',
            },
          ]
        },
        {
          seriesId: 'NC_Series',
          seriesName: 'Serie NC',
          productList:[
            // {
            //   productId: 'TOZO_NC2',
            //   productName: 'TOZO NC2',
            // },
            // {
            //   productId: 'TOZO_NC7',
            //   productName: 'TOZO NC7',
            // },
            {
              productId: 'TOZO_NC9',
              productName: 'TOZO NC9',
            },
            // {
            //   productId: 'TOZO_NC9_Plus',
            //   productName: 'TOZO NC9 Plus',
            // },
          ]
        },
        {
          seriesId: 'NC_Pro_Series',
          seriesName: 'Serie NC Pro',
          productList:[
            // {
            //   productId: 'TOZO_NC2_Pro',
            //   productName: 'TOZO NC2 Pro',
            // },
            {
              productId: 'TOZO_NC7_Pro',
              productName: 'TOZO NC7 Pro',
            },
            {
              productId: 'TOZO_NC9_Pro',
              productName: 'TOZO NC9 Pro',
            },
            {
              productId: 'TOZO_NC20_Pro',
              productName: 'TOZO NC20 Pro',
            },
            // {
            //   productId: 'TOZO_NC9_Pro_Max',
            //   productName: 'TOZO NC9 Pro Max',
            // },
          ]
        },
        {
          seriesId: 'A_Series',
          seriesName: 'Serie A',
          productList:[
            {
              productId: 'TOZO_A1',
              productName: 'TOZO A1',
            },
            // {
            //   productId: 'TOZO_A2',
            //   productName: 'TOZO A2',
            // },
            {
              productId: 'TOZO_A3',
              productName: 'TOZO A3',
            },
          ]
        },
        {
          seriesId: 'Agile_Series',
          seriesName: 'Serie ágil',
          productList:[
            {
              productId: 'TOZO_Agile_Pods',
              productName: 'TOZO Agile Pods',
            },
            {
              productId: 'TOZO_Agile_Dots',
              productName: 'TOZO Agile Dots',
            },
          ]
        },
        // {
        //   seriesId: 'G_Series',
        //   seriesName: 'Serie G',
        //   productList:[
        //     {
        //       productId: 'TOZO_G1',
        //       productName: 'TOZO G1',
        //     },
        //     {
        //       productId: 'TOZO_Gaming_Pods',
        //       productName: 'TOZO Gaming Pods',
        //     },
        //   ]
        // },
      ]
    },
    {
      categoryId: 'Watches',
      categoryName: 'Relojes',
      // seriesList:[
      //   {
      //     seriesId: 'Watches',
      //     seriesName: 'Relojes',
          productList:[
            // {
            //   productId: 'TOZO_S1',
            //   productName: 'TOZO S1',
            // },
            // {
            //   productId: 'TOZO_S2',
            //   productName: 'TOZO S2',
            // },
            // {
            //   productId: 'TOZO_S3',
            //   productName: 'TOZO S3',
            // },
            // {
            //   productId: 'TOZO_S4',
            //   productName: 'TOZO S4',
            // },
            {
              productId: 'TOZO_S5',
              productName: 'TOZO S5',
            },
            {
              productId: 'TOZO_S6',
              productName: 'TOZO S6',
            },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Speakers',
      categoryName: 'Oradores',
      // seriesList:[
      //   {
      //     seriesId: 'Speakers',
      //     seriesName: 'Oradores',
          productList:[
            {
              productId: 'TOZO_PA1',
              productName: 'TOZO PA1',
            },
            // {
            //   productId: 'TOZO_PA2',
            //   productName: 'TOZO PA2',
            // },
          ]
      //   }
      // ]
    },
    {
      categoryId: 'Panoramic_Camera',
      categoryName: 'Cámara panorámica',
      // seriesList:[
      //   {
      //     seriesId: 'Smart_audio_and_video',
      //     seriesName: 'Audio y vídeo inteligentes',
          productList:[
            {
              productId: 'AnyVue',
              productName: 'AnyVue',
            },
          ]
      //   }
      // ]
    },
    // {
    //   categoryId: 'Wireless_Charging',
    //   categoryName: 'Carga inalámbrica',
    //   seriesList:[
    //     {
    //       seriesId: 'Wireless_Charger',
    //       seriesName: 'Cargador inalámbrico',
    //       productList:[
    //         {
    //           productId: 'TOZO_W1',
    //           productName: 'TOZO W1',
    //         },
    //         {
    //           productId: 'TOZO_WB1',
    //           productName: 'TOZO WB1',
    //         },
    //         {
    //           productId: 'TOZO_W6',
    //           productName: 'TOZO W6',
    //         },
    //         {
    //           productId: 'TOZO_W8',
    //           productName: 'TOZO W8',
    //         },
    //         {
    //           productId: 'TOZO_W10',
    //           productName: 'TOZO W10',
    //         },
    //       ]
    //     }
    //   ]
    // },
    // {
    //   categoryId: 'Charger',
    //   categoryName: 'Cargador',
    //   seriesList:[
    //     {
    //       seriesId: 'Wall_Chargers',
    //       seriesName: 'Cargadores de pared',
    //       productList:[
    //         {
    //           productId: 'TOZO_C1',
    //           productName: 'TOZO C1',
    //         },
    //         {
    //           productId: 'TOZO_C2',
    //           productName: 'TOZO C2',
    //         },
    //       ]
    //     },
    //     {
    //       seriesId: 'Power_Banks',
    //       seriesName: 'Bancos de energía',
    //       productList:[
    //         {
    //           productId: 'TOZO_PB1',
    //           productName: 'TOZO PB1',
    //         },
    //         {
    //           productId: 'TOZO_PB2',
    //           productName: 'TOZO PB2',
    //         },
    //         {
    //           productId: 'TOZO_PB3',
    //           productName: 'TOZO PB3',
    //         },
    //       ]
    //     },
    //   ]
    // },
  ]

  //FAQ资源
  let faqList = [
    // {
    //   know_id:1,
    //   productId: 'TOZO_HT2',
    //   productName: 'TOZO HT2',
    //   browse: '',
    //   give: '',
    //   title: 'How to reset TOZO HT2?',
    //   description: `
    //     Restore factory settings
    //     When the headset is switched on. Press and hold the plus and
    //     minus keys simultaneously for 8 seconds to restore thefactory
    //     settings
    //   `
    // },
  ]

  //故障资源
  let TrobuleshootingList = [
    // {
    //   know_id:1,
    //   productId: 'TOZO_HT2',
    //   productName: 'TOZO HT2',
    //   browse: '',
    //   give: '',
    //   title: 'How to reset TOZO HT2?',
    //   description: `
    //     Restore factory settings
    //     When the headset is switched on. Press and hold the plus and
    //     minus keys simultaneously for 8 seconds to restore thefactory
    //     settings
    //   `
    // },
  ]

  //视频资源
  let videoHttps = 'https://s3-us-tozo-production.tozostore.com/support/video/'
  let language = 'EN'
  let VideoTutoralList = [
    //X系列
    {
      id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title: 'TOZO Golden X1',
      url: `${videoHttps}X1_${language}.mp4`,
    },
    //H系列
    {
      id:2,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title: 'TOZO HT2',
      url: `${videoHttps}HT2_${language}.mp4`,
    },
    {
      id:3,
      productId: 'TOZO_H10',
      productName: 'TOZO H10',
      title: 'TOZO H10',
      url: `${videoHttps}H10_${language}.mp4`,
    },
    //Open系列
    {
      id:4,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      title: 'TOZO OpenBuds',
      url: `${videoHttps}OpenBuds_${language}.mp4`,
    },
    {
      id:5,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title: 'TOZO OpenReal',
      url: `${videoHttps}Open_Real_${language}.mp4`,
    },
    {
      id:6,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title: 'TOZO OpenEgo',
      url: `${videoHttps}Open_Ego_${language}.mp4`,
    },
    //T系列
    {
      id:7,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title: 'TOZO T6',
      url: `${videoHttps}T6_${language}.mp4`,
    },
    {
      id:8,
      productId: 'TOZO_T6S',
      productName: 'TOZO T6S',
      title: 'TOZO T6S',
      url: `${videoHttps}T6S_${language}.mov`,
    },
    {
      id:9,
      productId: 'TOZO_T10S',
      productName: 'TOZO T10S',
      title: 'TOZO T10S',
      url: `${videoHttps}T10S_${language}.mp4`,
    },
    {
      id:10,
      productId: 'TOZO_Crystal_Buds',
      productName: 'TOZO Crystal Buds',
      title: 'TOZO Crystal Buds',
      url: `${videoHttps}T18_${language}.mp4`,
    },
    {
      id:11,
      productId: 'TOZO_T20',
      productName: 'TOZO T20',
      title: 'TOZO T20',
      url: `${videoHttps}T20_${language}.mp4`,
    },
    //Tonal系列
    {
      id:12,
      productId: 'TOZO_Tonal_Fits',
      productName: 'TOZO Tonal Fits',
      title: 'TOZO Tonal Fits',
      url: `${videoHttps}Tonal_Fits_${language}.mp4`,
    },
    {
      id:13,
      productId: 'TOZO_Tonal_Pots',
      productName: 'TOZO Tonal Pods',
      title: 'TOZO Tonal Pods',
      url: `${videoHttps}Tonal_Pods_${language}.mp4`,
    },
    //A系列
    {
      id:14,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title: 'TOZO A1',
      url: `${videoHttps}A1_${language}.mp4`,
    },
    {
      id:15,
      productId: 'TOZO_A3',
      productName: 'TOZO A3',
      title: 'TOZO A3',
      url: `${videoHttps}A3_${language}.mp4`,
    },
    //Agile系列
    {
      id:16,
      productId: 'TOZO_Agile_Dots',
      productName: 'TOZO Agile Dots',
      title: 'TOZO Agile Dots',
      url: `${videoHttps}Agile_Dots_${language}.mov`,
    },
    {
      id:17,
      productId: 'TOZO_Agile_Pods',
      productName: 'TOZO Agile Pods',
      title: 'TOZO Agile Pods',
      url: `${videoHttps}Agile_Pods_${language}.mov`,
    },
    //NC系列
    {
      id:18,
      productId: 'TOZO_NC7_Pro',
      productName: 'TOZO NC7 Pro',
      title: 'TOZO NC7 Pro',
      url: `${videoHttps}NC7_Pro${language}.mp4`,
    },
    {
      id:19,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      title: 'TOZO NC9 reiniciar',
      url: `${videoHttps}NC9_${language}.mp4`,
    },
    {
      id:20,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      title: 'TOZO NC9 limpieza y reinstalación de las olivas',
      url: `${videoHttps}NC9_2_${language}.mp4`,
    },
    {
      id:21,
      productId: 'TOZO_NC9_Pro',
      productName: 'TOZO NC9 Pro',
      title: 'TOZO NC9 Pro',
      url: `${videoHttps}NC9_Pro_${language}.mp4`,
    },
    {
      id:21,
      productId: 'TOZO_NC20_Pro',
      productName: 'TOZO NC20 Pro',
      title: 'TOZO NC20 Pro',
      url: `${videoHttps}NC20_Pro_${language}.mp4`,
    },

    //S系列 手表
    {
      id:22,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      title: 'TOZO S5',
      url: `${videoHttps}S5_${language}.mp4`,
    },
    {
      id:23,
      productId: 'TOZO_S6',
      productName: 'TOZO S6',
      title: 'Vídeo de desempaquetado del reloj inteligente TOZO S6',
      url: `${videoHttps}S6_${language}.mp4`,
    },
    {
      id:24,
      productId: 'TOZO_S6',
      productName: 'TOZO S6',
      title: 'TOZO S6 watch band installation video guide',
      url: `${videoHttps}S6_watch_band_installation_video_guide_${language}.mp4`,
    },

    //P系列 音箱
    {
      id:25,
      productId: 'TOZO_PA1',
      productName: 'TOZO PA1',
      title: 'TOZO PA1',
      url: `${videoHttps}PA1_${language}.mp4`,
    },

    //Panoramic Camera系列 相机
    {
      id:26,
      productId: 'AnyVue',
      productName: 'AnyVue',
      title: 'Tutorial rápido de uso compartido de AnyVue',
      url: `${videoHttps}AnyVue_quick_sharing_tutorial_${language}.mp4`,
    },
    {
      id:27,
      productId: 'AnyVue',
      productName: 'AnyVue',
      title: 'Video de enseñanza AnyVue: modificación de dictado con IA 2',
      url: `${videoHttps}AnyVue_teaching_video_AI_dictation_modification_2_${language}.mp4`,
    },
    {
      id:28,
      productId: 'AnyVue',
      productName: 'AnyVue',
      title: 'Enlace AnyVue Funcionamiento de VinsionPro',
      url: `${videoHttps}AnyVue_link_VinsionPro_operation_${language}.mp4`,
    },
    {
      id:29,
      productId: 'AnyVue',
      productName: 'AnyVue',
      title: 'Modificación del dictado en AI de la transmisión en vivo de YouTube de AnyVue',
      url: `${videoHttps}AnyVue_YouTube_live_broadcast_enAI_dictation_modification_${language}.mp4`,
    },
    {
      id:30,
      productId: 'AnyVue',
      productName: 'AnyVue',
      title: 'Modificación oral con IA del vídeo de pegado de películas AnyVue',
      url: `${videoHttps}AnyVue_film_pasting_video_AI_oral_modification_${language}.mp4`,
    },
  ]

  //说明书资源
  let TOZO_pdf_https = 'https://s3-us.tozostore.com/tozo/pdfRenderer/web/'
  let Anybuds_pdf_https = 'https://s3-prod.anybuds.com/pdfRenderer/web/'
  let UserManual = 'UserManual'
  let QuickGuide = 'QuickGuide'

  let TOZO = 'TOZO'
  let Anybuds = 'Anybuds'

  // TOZO
  let preview_TOZO_UserManual_Url = `${TOZO_pdf_https}index.html?file=docs/${UserManual}/${TOZO}/`//预览用户指南
  let download_TOZO_UserManual_Url = `${TOZO_pdf_https}docs/${UserManual}/${TOZO}/` //下载用户指南

  let preview_TOZO_QuickGuide_Url = `${TOZO_pdf_https}index.html?file=docs/${QuickGuide}/${TOZO}/`//预览快速指引
  let download_TOZO_QuickGuide_Url = `${TOZO_pdf_https}docs/${QuickGuide}/${TOZO}/` //下载快速指引

  // Anybuds
  let preview_Anybuds_UserManual_Url = `${Anybuds_pdf_https}index.html?file=docs/${UserManual}/${Anybuds}/`//预览用户指南
  let download_Anybuds_UserManual_Url = `${Anybuds_pdf_https}docs/${UserManual}/${Anybuds}/` //下载用户指南

  let preview_Anybuds_QuickGuide_Url = `${Anybuds_pdf_https}index.html?file=docs/${QuickGuide}/${Anybuds}/`//预览快速指引
  let download_Anybuds_QuickGuide_Url = `${Anybuds_pdf_https}docs/${QuickGuide}/${Anybuds}/` //下载快速指引
  
  // https://s3-us.tozostore.com/tozo/pdfRenderer/web/docs/QuickGuide/TOZO/T6.pdf
  // https://s3-us.tozostore.com/tozo/pdfRenderer/web/index.html?file=docs/UserManual/TOZO/T6.pdf
  // https://s3-prod.anybuds.com/pdfRenderer/web/index.html?file=docs/UserManual/Anybuds/Clips.pdf
  let manualsList = [
    {
      id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title:'TOZO Golden X1 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}X1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}X1.pdf`,
    },
    {
      id:2,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title:'TOZO Golden X1 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}X1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}X1.pdf`,
    },

    {
      id:3,
      productId: 'TOZO_Color_Pods',
      productName: 'TOZO Color Pods',
      title:'TOZO Color Pods Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Color_Pods.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Color_Pods.pdf`,
    },
    // {
    //   id:4,
    //   productId: 'TOZO_Color_Pods',
    //   productName: 'TOZO Color Pods',
    //   title:'TOZO Color Pods Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Color_Pods.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Color_Pods.pdf`,
    // },

    {
      id:5,
      productId: 'TOZO_HA1',
      productName: 'TOZO HA1',
      title:'TOZO HA1 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}HA1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}HA1.pdf`,
    },
    // {
    //   id:6,
    //   productId: 'TOZO_HA1',
    //   productName: 'TOZO HA1',
    //   title:'TOZO HA1 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}HA1.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}HA1.pdf`,
    // },

    // {
    //   id:7,
    //   productId: 'TOZO_HT1',
    //   productName: 'TOZO HT1',
    //   title:'TOZO HA1 Manual de usuario',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}HT1.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}HT1.pdf`,
    // },
    {
      id:8,
      productId: 'TOZO_HT1',
      productName: 'TOZO HT1',
      title:'TOZO HT1 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}HT1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}HT1.pdf`,
    },
    

    {
      id:9,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title:'TOZO HT2 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}HT2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}HT2.pdf`,
    },
    {
      id:10,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title:'TOZO HT2 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}HT2.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}HT2.pdf`,
    },

    {
      id:11,
      productId: 'TOZO_Open_X2_Pro',
      productName: 'TOZO Open X2 Pro',
      title:'TOZO Open X2 Pro Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_X2_Pro.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_X2_Pro.pdf`,
    },
    // {
    //   id:12,
    //   productId: 'TOZO_Open_X2_Pro',
    //   productName: 'TOZO Open X2 Pro',
    //   title:'TOZO Open X2 Pro Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_X2_Pro.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_X2_Pro.pdf`,
    // },

    {
      id:11,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      title:'TOZO Open Buds Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Buds.pdf`,
    },
    {
      id:12,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      title:'TOZO Open Buds Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Buds.pdf`,
    },

    {
      id:13,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title:'TOZO OpenReal Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Real.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Real.pdf`,
    },
    {
      id:14,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title:'TOZO OpenReal Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Real.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Real.pdf`,
    },

    {
      id:15,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title:'TOZO OpenEgo Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Ego.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Ego.pdf`,
    },
    {
      id:16,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title:'TOZO OpenEgo Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Ego.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Ego.pdf`,
    },

    {
      id:17,
      productId: 'TOZO_Open_EarRing',
      productName: 'TOZO Open EarRing',
      title:'TOZO Open EarRing Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_EarRing.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_EarRing.pdf`,
    },
    // {
    //   id:18,
    //   productId: 'TOZO_Open_EarRing',
    //   productName: 'TOZO Open EarRing',
    //   title:'TOZO Open EarRing Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_EarRing.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_EarRing.pdf`,
    // },

    // {
    //   id:19,
    //   productId: 'TOZO_Open_EarRing',
    //   productName: 'TOZO Open EarRing',
    //   title:'TOZO Open EarRing (New) Manual de usuario',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_EarRing-0xCF.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_EarRing-0xCF.pdf`,
    // },
    // {
    //   id:20,
    //   productId: 'TOZO_Open_EarRing',
    //   productName: 'TOZO Open EarRing',
    //   title:'TOZO Open EarRing (New) Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_EarRing-0xCF.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_EarRing-0xCF.pdf`,
    // },

    {
      id:21,
      productId: 'TOZO_O2',
      productName: 'TOZO O2',
      title:'TOZO O2 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}O2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}O2.pdf`,
    },
    // {
    //   id:22,
    //   productId: 'TOZO_O2',
    //   productName: 'TOZO O2',
    //   title:'TOZO O2 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}O2.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}O2.pdf`,
    // },

    // {
    //   id:23,
    //   productId: 'TOZO_OpenWear',
    //   productName: 'TOZO OpenWear',
    //   title:'TOZO OpenWear Manual de usuario',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}OpenWear.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}OpenWear.pdf`,
    // },
    // {
    //   id:24,
    //   productId: 'TOZO_OpenWear',
    //   productName: 'TOZO OpenWear',
    //   title:'TOZO OpenWear Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}OpenWear.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}OpenWear.pdf`,
    // },

    {
      id:25,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title:'TOZO T6 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T6.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T6.pdf`,
    },
    {
      id:26,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title:'TOZO T6 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T6.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T6.pdf`,
    },

    {
      id:27,
      productId: 'TOZO_T6_Mini',
      productName: 'TOZO T6 Mini',
      title:'TOZO T6 Mini Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T6_Mini.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T6_Mini.pdf`,
    },
    {
      id:28,
      productId: 'TOZO_T6_Mini',
      productName: 'TOZO T6 Mini',
      title:'TOZO T6 Mini Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T6_Mini.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T6_Mini.pdf`,
    },

    // {
    //   id:29,
    //   productId: 'TOZO_T6_Mini',
    //   productName: 'TOZO T6 Mini',
    //   title:'TOZO T6 Mini (New) Manual de usuario',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T6_Mini-juxin.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}T6_Mini-juxin.pdf`,
    // },
    // {
    //   id:30,
    //   productId: 'TOZO_T6_Mini',
    //   productName: 'TOZO T6 Mini',
    //   title:'TOZO T6 Mini (New) Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T6_Mini-juxin.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T6_Mini-juxin.pdf`,
    // },

    {
      id:31,
      productId: 'TOZO_T10',
      productName: 'TOZO T10',
      title:'TOZO T10 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T10.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T10.pdf`,
    },
    {
      id:32,
      productId: 'TOZO_T10',
      productName: 'TOZO T10',
      title:'TOZO T10 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T10.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T10.pdf`,
    },

    {
      id:33,
      productId: 'TOZO_T10_Mini',
      productName: 'TOZO T10 Mini',
      title:'TOZO T10 Mini Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T10_Mini.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T10_Mini.pdf`,
    },
    {
      id:34,
      productId: 'TOZO_T10_Mini',
      productName: 'TOZO T10 Mini',
      title:'TOZO T10 Mini Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T10_Mini.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T10_Mini.pdf`,
    },

    // {
    //   id:35,
    //   productId: 'TOZO_T10_Mini',
    //   productName: 'TOZO T10 Mini',
    //   title:'TOZO T10 Mini (new) Manual de usuario',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T10_Mini-juxin.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}T10_Mini-juxin.pdf`,
    // },
    // {
    //   id:36,
    //   productId: 'TOZO_T10_Mini',
    //   productName: 'TOZO T10 Mini',
    //   title:'TOZO T10 Mini (new) Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T10_Mini-juxin.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T10_Mini-juxin.pdf`,
    // },

    {
      id:37,
      productId: 'TOZO_T9',
      productName: 'TOZO T9',
      title:'TOZO T9 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T9.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T9.pdf`,
    },
    {
      id:38,
      productId: 'TOZO_T9',
      productName: 'TOZO T9',
      title:'TOZO T9 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T9.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T9.pdf`,
    },

    {
      id:39,
      productId: 'TOZO_T12',
      productName: 'TOZO T12',
      title:'TOZO T12 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T12.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T12.pdf`,
    },
    {
      id:40,
      productId: 'TOZO_T12',
      productName: 'TOZO T12',
      title:'TOZO T12 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T12.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T12.pdf`,
    },

    {
      id:41,
      productId: 'TOZO_T12_Pro',
      productName: 'TOZO T12 Pro',
      title:'TOZO T12 Pro Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T12_Pro.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T12_Pro.pdf`,
    },
    {
      id:42,
      productId: 'TOZO_T12_Pro',
      productName: 'TOZO T12 Pro',
      title:'TOZO T12 Pro Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T12_Pro.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T12_Pro.pdf`,
    },

    {
      id:43,
      productId: 'TOZO_T20',
      productName: 'TOZO T20',
      title:'TOZO T20 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T20.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T20.pdf`,
    },
    {
      id:44,
      productId: 'TOZO_T20',
      productName: 'TOZO T20',
      title:'TOZO T20 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T20.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T20.pdf`,
    },

    {
      id:45,
      productId: 'TOZO_T21',
      productName: 'TOZO T21',
      title:'TOZO T21 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T21.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T21.pdf`,
    },
    {
      id:46,
      productId: 'TOZO_T21',
      productName: 'TOZO T21',
      title:'TOZO T21 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T21.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T21.pdf`,
    },

    {
      id:47,
      productId: 'TOZO_Tonal_Dots',
      productName: 'TOZO Tonal Dots',
      title:'TOZO Tonal Dot Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Tonal_Dots.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Tonal_Dots.pdf`,
    },
    {
      id:48,
      productId: 'TOZO_Tonal_Dots',
      productName: 'TOZO Tonal Dots',
      title:'TOZO Tonal Dot Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Tonal_Dots.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Tonal_Dots.pdf`,
    },

    {
      id:49,
      productId: 'TOZO_Tonal_Fits',
      productName: 'TOZO Tonal Fits',
      title:'TOZO Tonal Fits Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Tonal_Fits.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Tonal_Fits.pdf`,
    },
    {
      id:50,
      productId: 'TOZO_Tonal_Fits',
      productName: 'TOZO Tonal Fits',
      title:'TOZO Tonal Fits Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Tonal_Fits.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Tonal_Fits.pdf`,
    },

    {
      id:51,
      productId: 'TOZO_Crystal_Buds',
      productName: 'TOZO Crystal Buds',
      title:'TOZO Crystal Buds Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Crystal_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Crystal_Buds.pdf`,
    },
    {
      id:52,
      productId: 'TOZO_Crystal_Buds',
      productName: 'TOZO Crystal Buds',
      title:'TOZO Crystal Buds Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Crystal_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Crystal_Buds.pdf`,
    },

    {
      id:53,
      productId: 'TOZO_NC2',
      productName: 'TOZO NC2',
      title:'TOZO NC2 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC2.pdf`,
    },
    {
      id:54,
      productId: 'TOZO_NC2',
      productName: 'TOZO NC2',
      title:'TOZO NC2 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC2.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC2.pdf`,
    },

    {
      id:55,
      productId: 'TOZO_NC3',
      productName: 'TOZO NC3',
      title:'TOZO NC3 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC3.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC3.pdf`,
    },
    // {
    //   id:56,
    //   productId: 'TOZO_NC3',
    //   productName: 'TOZO NC3',
    //   title:'TOZO NC3 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC3.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC3.pdf`,
    // },

    // {
    //   id:57,
    //   productId: 'TOZO_NC3',
    //   productName: 'TOZO NC3',
    //   title:'TOZO NC3 (New) Manual de usuario',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC3-0xCB.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}NC3-0xCB.pdf`,
    // },
    // {
    //   id:58,
    //   productId: 'TOZO_NC3',
    //   productName: 'TOZO NC3',
    //   title:'TOZO NC3 (New) Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC3-0xCB.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC3-0xCB.pdf`,
    // },

    {
      id:59,
      productId: 'TOZO_NC7',
      productName: 'TOZO NC7',
      title:'TOZO NC7 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC7.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC7.pdf`,
    },
    {
      id:60,
      productId: 'TOZO_NC7',
      productName: 'TOZO NC7',
      title:'TOZO NC7 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC7.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC7.pdf`,
    },

    {
      id:61,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      title:'TOZO NC9 (New T11124) Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC9_new.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC9_new.pdf`,
    },
    // {
    //   id:62,
    //   productId: 'TOZO_NC9',
    //   productName: 'TOZO NC9',
    //   title:'TOZO NC9 (New) Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC9_new.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC9_new.pdf`,
    // },

    {
      id:63,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      title:'TOZO NC9 (viejo) Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC9.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC9.pdf`,
    },
    {
      id:64,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      title:'TOZO NC9 (viejo) Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC9.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC9.pdf`,
    },

    //添加霍尔开关版本
    // {
    //   id:66,
    //   productId: 'TOZO_NC9',
    //   productName: 'TOZO NC9',
    //   title:'TOZO NC9 (New) Manual de usuario',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC9_new.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}NC9_new.pdf`,
    // },
    // {
    //   id:67,
    //   productId: 'TOZO_NC9',
    //   productName: 'TOZO NC9',
    //   title:'TOZO NC9 (New) Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC9_new.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC9_new.pdf`,
    // },

    {
      id:63,
      productId: 'TOZO_NC20',
      productName: 'TOZO NC20',
      title:'TOZO NC20 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC20.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC20.pdf`,
    },
    // {
    //   id:64,
    //   productId: 'TOZO_NC20',
    //   productName: 'TOZO NC20',
    //   title:'TOZO NC20 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC20.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC20.pdf`,
    // },

    {
      id:63,
      productId: 'TOZO_NC20_Pro',
      productName: 'TOZO NC20 Pro',
      title:'TOZO NC20 Pro Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}NC20_Pro.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}NC20_Pro.pdf`,
    },
    // {
    //   id:64,
    //   productId: 'TOZO_NC20_Pro',
    //   productName: 'TOZO NC20 Pro',
    //   title:'TOZO NC20 Pro Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}NC20_Pro.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}NC20_Pro.pdf`,
    // },

    {
      id:68,
      productId: 'TOZO_Crystal_Pods',
      productName: 'TOZO Crystal Pods',
      title:'TOZO Crystal Pods Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Crystal_Pods.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Crystal_Pods.pdf`,
    },
    // {
    //   id:69,
    //   productId: 'TOZO_Crystal_Pods',
    //   productName: 'TOZO Crystal Pods',
    //   title:'TOZO Crystal Pods Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Crystal_Pods.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Crystal_Pods.pdf`,
    // },

    {
      id:70,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title:'TOZO A1 (New) Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A1_new.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A1_new.pdf`,
    },
    // {
    //   id:71,
    //   productId: 'TOZO_A1_new',
    //   productName: 'TOZO A1_new',
    //   title:'TOZO A1_new Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}A1_new.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}A1_new.pdf`,
    // },

    {
      id:72,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title:'TOZO A1 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A1.pdf`,
    },
    {
      id:73,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title:'TOZO A1 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}A1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}A1.pdf`,
    },

    {
      id:74,
      productId: 'TOZO_A2',
      productName: 'TOZO A2',
      title:'TOZO A2 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A2.pdf`,
    },
    {
      id:75,
      productId: 'TOZO_A2',
      productName: 'TOZO A2',
      title:'TOZO A2 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}A2.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}A2.pdf`,
    },

    {
      id:76,
      productId: 'TOZO_A3',
      productName: 'TOZO A3',
      title:'TOZO A3 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A3.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A3.pdf`,
    },
    {
      id:77,
      productId: 'TOZO_A3',
      productName: 'TOZO A3',
      title:'TOZO A3 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}A3.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}A3.pdf`,
    },
    //支持app
    {
      id:78,
      productId: 'TOZO_A3',
      productName: 'TOZO A3',
      title:'Manual de usuario de TOZO A3 (aplicación de soporte)',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A3_APP.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A3_APP.pdf`,
    },
    

    {
      id:79,
      productId: 'TOZO_E1',
      productName: 'TOZO E1',
      title:'TOZO E1 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}E1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}E1.pdf`,
    },
    // {
    //   id:80,
    //   productId: 'TOZO_E1',
    //   productName: 'TOZO E1',
    //   title:'TOZO E1 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}E1.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}E1.pdf`,
    // },

    {
      id:81,
      productId: 'TOZO_E2',
      productName: 'TOZO E2',
      title:'TOZO E2 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}E2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}E2.pdf`,
    },
    // {
    //   id:82,
    //   productId: 'TOZO_E2',
    //   productName: 'TOZO E2',
    //   title:'TOZO E2 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}E2.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}E2.pdf`,
    // },

    {
      id:83,
      productId: 'TOZO_Watch1',
      productName: 'TOZO Watch1',
      title:'TOZO Watch1 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Watch1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Watch1.pdf`,
    },
    // {
    //   id:84,
    //   productId: 'TOZO_Watch1',
    //   productName: 'TOZO Watch1',
    //   title:'TOZO Watch1 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Watch1.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Watch1.pdf`,
    // },

    {
      id:85,
      productId: 'TOZO_S2',
      productName: 'TOZO S2',
      title:'TOZO S2 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}S2.pdf`,
    },
    // {
    //   id:86,
    //   productId: 'TOZO_S2',
    //   productName: 'TOZO S2',
    //   title:'TOZO S2 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S2.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S2.pdf`,
    // },

    // {
    //   id:87,
    //   productId: 'TOZO_S3',
    //   productName: 'TOZO S3',
    //   title:'TOZO S3 Manual de usuario',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S3.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}S3.pdf`,
    // },
    // {
    //   id:88,
    //   productId: 'TOZO_S3',
    //   productName: 'TOZO S3',
    //   title:'TOZO S3 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S3.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S3.pdf`,
    // },
    
    // {
    //   id:89,
    //   productId: 'TOZO_S4',
    //   productName: 'TOZO S4',
    //   title:'TOZO S4 Manual de usuario',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S4.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}S4.pdf`,
    // },
    // {
    //   id:90,
    //   productId: 'TOZO_S4',
    //   productName: 'TOZO S4',
    //   title:'TOZO S4 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S4.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S4.pdf`,
    // },

    {
      id:91,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      title:'TOZO S5 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S5.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}S5.pdf`,
    },
    // {
    //   id:92,
    //   productId: 'TOZO_S5',
    //   productName: 'TOZO S5',
    //   title:'TOZO S5 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S5.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S5.pdf`,
    // },

    // {
    //   id:93,
    //   productId: 'TOZO_S6',
    //   productName: 'TOZO S6',
    //   title:'TOZO S6 Manual de usuario',
    //   preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S6.pdf`,
    //   download_TOZO_Url: `${download_TOZO_UserManual_Url}S6.pdf`,
    // },
    // {
    //   id:94,
    //   productId: 'TOZO_S6',
    //   productName: 'TOZO S6',
    //   title:'TOZO S6 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S6.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S6.pdf`,
    // },

    {
      id:95,
      productId: 'TOZO_S7',
      productName: 'TOZO S7',
      title:'TOZO S7 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S7.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}S7.pdf`,
    },
    // {
    //   id:96,
    //   productId: 'TOZO_S7',
    //   productName: 'TOZO S7',
    //   title:'TOZO S7 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S7.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S7.pdf`,
    // },

    {
      id:98,
      productId: 'TOZO_S8',
      productName: 'TOZO S8',
      title:'TOZO S8 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S8.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}S8.pdf`,
    },
    // {
    //   id:99,
    //   productId: 'TOZO_S8',
    //   productName: 'TOZO S8',
    //   title:'TOZO S8 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S8.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S8.pdf`,
    // },

    {
      id:100,
      productId: 'TOZO_AcuFit_Lite',
      productName: 'TOZO AcuFit Lite',
      title:'TOZO AcuFit Lite Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}AcuFit_Lite.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_Lite.pdf`,
    },
    // {
    //   id:101,
    //   productId: 'TOZO_AcuFit_Lite',
    //   productName: 'TOZO AcuFit Lite',
    //   title:'TOZO AcuFit Lite Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}AcuFit_Lite.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}AcuFit_Lite.pdf`,
    // },

    {
      id:102,
      productId: 'TOZO_AcuFit_One',
      productName: 'TOZO AcuFit One',
      title:'TOZO AcuFit One Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}AcuFit_One.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_One.pdf`,
    },
    // {
    //   id:103,
    //   productId: 'TOZO_AcuFit_One',
    //   productName: 'TOZO AcuFit One',
    //   title:'TOZO AcuFit One Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}AcuFit_One.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}AcuFit_One.pdf`,
    // },

    {
      id:104,
      productId: 'TOZO_AcuFit_GT',
      productName: 'TOZO AcuFit GT',
      title:'TOZO AcuFit GT Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}AcuFit_GT.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_GT.pdf`,
    },
    // {
    //   id:105,
    //   productId: 'TOZO_AcuFit_GT',
    //   productName: 'TOZO AcuFit GT',
    //   title:'TOZO AcuFit GT Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}AcuFit_GT.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}AcuFit_GT.pdf`,
    // },
    

    {
      id:106,
      productId: 'TOZO_AcuFit_Solo',
      productName: 'TOZO AcuFit Solo',
      title:'TOZO AcuFit Solo Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}AcuFit_Solo.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_Solo.pdf`,
    },
    // {
    //   id:107,
    //   productId: 'TOZO_AcuFit_Solo',
    //   productName: 'TOZO AcuFit_Solo',
    //   title:'TOZO AcuFit Solo Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}AcuFit_Solo.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}AcuFit_Solo.pdf`,
    // },

    {
      id:108,
      productId: 'TOZO_AcuFit_Evo',
      productName: 'TOZO AcuFit Evo',
      title:'TOZO AcuFit Evo Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}AcuFit_Evo.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}AcuFit_Evo.pdf`,
    },
    // {
    //   id:109,
    //   productId: 'TOZO_AcuFit_Evo',
    //   productName: 'TOZO AcuFit Evo',
    //   title:'TOZO AcuFit Evo Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}AcuFit_Evo.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}AcuFit_Evo.pdf`,
    // },

    {
      id:110,
      productId: 'TOZO_PA1',
      productName: 'TOZO PA1',
      title:'TOZO PA1 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}PA1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}PA1.pdf`,
    },
    {
      id:111,
      productId: 'TOZO_PA1',
      productName: 'TOZO PA1',
      title:'TOZO PA1 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}PA1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}PA1.pdf`,
    },

    {
      id:112,
      productId: 'TOZO_PE1',
      productName: 'TOZO PE1',
      title:'TOZO PE1 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}PE1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}PE1.pdf`,
    },
    {
      id:113,
      productId: 'TOZO_PE1',
      productName: 'TOZO PE1',
      title:'TOZO PE1 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}PE1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}PE1.pdf`,
    },

    {
      id:114,
      productId: 'TOZO_W1',
      productName: 'TOZO W1',
      title:'TOZO W1 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}W1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}W1.pdf`,
    },
    // {
    //   id:115,
    //   productId: 'TOZO_W1',
    //   productName: 'TOZO W1',
    //   title:'TOZO W1 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}W1.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}W1.pdf`,
    // },

    {
      id:116,
      productId: 'TOZO_W6',
      productName: 'TOZO W6',
      title:'TOZO W6 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}W6.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}W6.pdf`,
    },
    // {
    //   id:117,
    //   productId: 'TOZO_W6',
    //   productName: 'TOZO W6',
    //   title:'TOZO W6 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}W6.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}W6.pdf`,
    // },

    {
      id:118,
      productId: 'TOZO_W10',
      productName: 'TOZO W10',
      title:'TOZO W10 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}W10.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}W10.pdf`,
    },
    // {
    //   id:119,
    //   productId: 'TOZO_W10',
    //   productName: 'TOZO W10',
    //   title:'TOZO W10 Guía rápida',
    //   preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}W10.pdf`,
    //   download_TOZO_Url: `${download_TOZO_QuickGuide_Url}W10.pdf`,
    // },


    // Anybuds
    // {
    //   id:120,
    //   productId: 'Anybuds_Clips',
    //   productName: 'Anybuds Clips',
    //   title:'Anybuds Clips Manual de usuario',
    //   preview_TOZO_Url: `${preview_Anybuds_UserManual_Url}Clips.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_UserManual_Url}Clips.pdf`,
    // },
    // {
    //   id:121,
    //   productId: 'Anybuds_Clips',
    //   productName: 'Anybuds Clips',
    //   title:'Anybuds Clips Guía rápida',
    //   preview_TOZO_Url: `${preview_Anybuds_QuickGuide_Url}Clips.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Clips.pdf`,
    // },

    // {
    //   id:122,
    //   productId: 'Anybuds_Dots',
    //   productName: 'Anybuds Dots',
    //   title:'Anybuds Dots Manual de usuario',
    //   preview_TOZO_Url: `${preview_Anybuds_UserManual_Url}Dots.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_UserManual_Url}Dots.pdf`,
    // },
    // {
    //   id:123,
    //   productId: 'Anybuds_Dots',
    //   productName: 'Anybuds Dots',
    //   title:'Anybuds Dots Guía rápida',
    //   preview_TOZO_Url: `${preview_Anybuds_QuickGuide_Url}Dots.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Dots.pdf`,
    // },

    // // {
    // //   id:124,
    // //   productId: 'Anybuds_Fits',
    // //   productName: 'Anybuds Fits',
    // //   title:'Anybuds Fits Manual de usuario',
    // //   preview_TOZO_Url: `${preview_Anybuds_UserManual_Url}Fits.pdf`,
    // //   download_TOZO_Url: `${download_Anybuds_UserManual_Url}Fits.pdf`,
    // // },
    // {
    //   id:125,
    //   productId: 'Anybuds_Fits',
    //   productName: 'Anybuds Fits',
    //   title:'Anybuds Fits Guía rápida',
    //   preview_TOZO_Url: `${preview_Anybuds_QuickGuide_Url}Fits.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Fits.pdf`,
    // },

    // // {
    // //   id:126,
    // //   productId: 'Anybuds_Pro',
    // //   productName: 'Anybuds Pro',
    // //   title:'Anybuds Pro Manual de usuario',
    // //   preview_TOZO_Url: `${preview_Anybuds_UserManual_Url}Pro.pdf`,
    // //   download_TOZO_Url: `${download_Anybuds_UserManual_Url}Pro.pdf`,
    // // },
    // {
    //   id:127,
    //   productId: 'Anybuds_Pro',
    //   productName: 'Anybuds Pro',
    //   title:'Anybuds Pro Guía rápida',
    //   preview_TOZO_Url: `${preview_Anybuds_QuickGuide_Url}Pro.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Pro.pdf`,
    // },

    // {
    //   id:128,
    //   productId: 'Anybuds_Vivid',
    //   productName: 'Anybuds Vivid',
    //   title:'Anybuds Vivid Manual de usuario',
    //   preview_TOZO_Url: `${preview_Anybuds_UserManual_Url}Vivid.pdf`,
    //   download_TOZO_Url: `${download_Anybuds_UserManual_Url}Vivid.pdf`,
    // },
    // // {
    // //   id:129,
    // //   productId: 'Anybuds_Vivid',
    // //   productName: 'Anybuds Vivid',
    // //   title:'Anybuds Vivid Guía rápida',
    // //   preview_TOZO_Url: `${preview_Anybuds_QuickGuide_Url}Vivid.pdf`,
    // //   download_TOZO_Url: `${download_Anybuds_QuickGuide_Url}Vivid.pdf`,
    // // },

  ]
  
  //热门FAQ资源
  let hot_faqList = [
    {
      know_id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      browse: '',
      give: '',
      title: '¿Por qué los auriculares no mantienen la carga?',
      description: `
      Verifique si el conector de metal está sucio, intente limpiarlo suavemente con un paño seco, un clip o toallas de papel.
      (El sudor o la humedad también pueden provocar la desconexión) <br/>
      2. Cargue completamente la caja de la batería al principio sin colocar los auriculares. <br/>
      · Cambie los auriculares izquierdo y derecho para cargarlos y probar. <br/>
      · Coloque el izquierdo en el lado derecho de la caja, al igual que el auricular derecho, que se coloca en el lado izquierdo de la caja. <br/>
      · Confirme si se trata de un problema de la caja de la batería después de realizar los pasos anteriores. <br/>
      3. Restablecer podría resolver muchos de los problemas que se produjeron. <br/>
      `
    },
    {
      know_id:2,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      browse: '',
      give: '',
      title: '¿Cómo ajustar el volumen con los auriculares?',
      description: `
      Mantenga presionado el auricular L o R para ajustar el volumen mientras reproduce música. <br/>
      Volumen del auricular R + <br/>
      Volumen del auricular L - <br/>
      El ajuste del volumen no está disponible cuando está conectado a un televisor y una computadora. <br/>
      `
    },
    {
      know_id:3,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      browse: '',
      give: '',
      title: '¿Qué debo hacer si la computadora dice que necesita un controlador o transmisor para conectar los auriculares?',
      description: `
      A continuación, se incluyen algunos métodos para su referencia. <br/>
      ·Descargue un receptor Bluetooth para conectar (en la configuración de la computadora) <br/>
      ·Verifique si la versión de Bluetooth de su computadora es compatible con Bluetooth 5.0 <br/>
      `
    },
    {
      know_id:4,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      browse: '',
      give: '',
      title: '¿Cuáles son las características principales de los auriculares TOZO HT2?',
      description: `
      Los TOZO HT2 ofrecen cancelación activa de ruido adaptativa híbrida, unidades de controlador dinámico de 40 mm, certificación de audio de alta resolución y cancelación de ruido de llamadas 3-MIC ENC.
      `
    },
    {
      know_id:5,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      browse: '',
      give: '',
      title: '¿Qué hace que los auriculares TOZO Open Buds sean únicos?',
      description: `
      Los auriculares TOZO Open Buds cuentan con un innovador diseño de rotación biaxial para una comodidad personalizable y un diseño de oído abierto que le permite estar atento a su entorno.
      `
    },
    {
      know_id:6,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      browse: '',
      give: '',
      title: '¿Cómo es la calidad de sonido de los auriculares TOZO Open Buds?',
      description: `
      Los grandes controladores dinámicos de 14,2 mm ofrecen un sonido claro y de alta calidad con graves potentes.
      `
    },
    {
      know_id:7,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      browse: '',
      give: '',
      title: '¿Son cómodos de usar los auriculares TOZO Open Buds?',
      description: `
      Sí, el diseño de rotación biaxial permite un ajuste en múltiples ángulos, lo que brinda máxima comodidad durante el uso prolongado.
      `
    },
    {
      know_id:8,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      browse: '',
      give: '',
      title: '¿Cuáles son las características principales de los auriculares TOZO OpenReal?',
      description: `
      Los TOZO OpenReal cuentan con un diseño de oído abierto, tecnología de conducción de aire,
      Bluetooth 5.3, ENC de doble micrófono para cancelación de ruido en llamadas y controladores dinámicos 
      de 16,2 mm para un sonido claro y potente.
      `
    },
    {
      know_id:9,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      browse: '',
      give: '',
      title: '¿Cómo es la calidad de sonido de los auriculares TOZO OpenReal?',
      description: `
      Los controladores dinámicos de 16,2 mm brindan un sonido hermoso con agudos claros y graves potentes.
      `
    },
    {
      know_id:10,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      browse: '',
      give: '',
      title: '¿Cuáles son las principales características de los auriculares TOZO OpenEgo?',
      description: `
      Los TOZO OpenEgo cuentan con un diseño de oído abierto para mayor comodidad, tecnología de 
      conducción de aire para una música clara, Bluetooth 5.3 para una conexión estable, DNS de doble micrófono para cancelación de ruido en llamadas y controladores dinámicos de 16,2 mm para un sonido de alta calidad.
      `
    },
    {
      know_id:11,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      browse: '',
      give: '',
      title: '¿Qué funciones de cancelación de ruido tienen los auriculares TOZO OpenEgo?',
      description: `
      Cuentan con tecnología DNS (supresión de ruido digital) de doble micrófono para llamadas claras al minimizar el ruido de fondo.
      `
    },
    {
      know_id:12,
      productId: 'TOZO_PA2',
      productName: 'TOZO PA2',
      browse: '',
      give: '',
      title: '¿Cuáles son las características principales del altavoz Bluetooth TOZO PA2?',
      description: `
      El TOZO PA2 ofrece un sonido estéreo envolvente, tres modos de ecualización, 25 horas de reproducción, resistencia al agua IPX8 y llamadas por Bluetooth.
      `
    },
    {
      know_id:13,
      productId: 'TOZO_S1',
      productName: 'TOZO S1',
      browse: '',
      give: '',
      title: '¿Este reloj es resistente al agua?',
      description: `
      Sí, este reloj es resistente al agua y apto para el uso diario, pero se recomienda evitar la inmersión prolongada en el agua.
      `
    },
  ]

  //热门故障资源
  let hot_TrobuleshootingList = [
    {
      know_id:1,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      browse: '',
      give: '',
      title: '¿Cómo restablecer los TOZO HT2?',
      description: `
      Restaurar la configuración de fábrica Cuando el auricular esté encendido. Mantenga presionadas las teclas más y menos simultáneamente durante 8 segundos para restaurar la configuración de fábrica.
      `
    },
    
    {
      know_id:2,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      browse: '',
      give: '',
      title: '¿Cómo restablecer los TOZO OpenReal?',
      description: `
      Cuando los auriculares estén colocados en el estuche de carga, mantenga presionado el botón del estuche de carga durante 8 segundos para borrar los registros de emparejamiento de Bluetooth y restaurar la configuración de fábrica.
      `
    },
    
    {
      know_id:3,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      browse: '',
      give: '',
      title: '¿Cómo restablecer los TOZO Open Buds?',
      description: `
      Los auriculares (o uno de ellos) no se emparejan o no se conectan/ El sonido se corta/ Los auriculares no se pueden encontrar en la búsqueda de Bluetooth <br/>

      Si uno de los auriculares no funciona o no se empareja, reinícielo: <br/>
      Mantenga presionada simultáneamente la zona táctil y el botón "-" durante 5 segundos. La luz indicadora se apagará <br/>
      y luego parpadeará en rojo y blanco, lo que indica que el restablecimiento se realizó correctamente.
      `
    },
    
    {
      know_id:4,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar TOZO OpenEgo?',
      description: `
      7.0 Reiniciar <br/>
      Si accidentalmente solo funciona un auricular o no se pueden emparejar entre sí, reinícielo: <br/>
      Cuando los auriculares estén encendidos y en modo de emparejamiento, toque rápidamente cualquiera de los auriculares seis veces. <br/>
      Después de que la luz indicadora blanca parpadee rápidamente seis veces, una luz roja permanecerá encendida durante 1 segundo, lo que indica que los auriculares están apagados. Después de apagarlos, los auriculares se encenderán automáticamente, lo que indica un restablecimiento de fábrica exitoso. <br/>
      Nota: En caso de que la conexión no sea exitosa en sus dispositivos, elimine todos los registros históricos de [TOZO OpenEgo] e intente el proceso de emparejamiento nuevamente.
      `
    },
    
    {
      know_id:5,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar TOZO Golden X1?',
      description: `
      1. Coloque los auriculares en el estuche de carga. <br/>
      2. Mantenga presionado el botón del estuche durante 15 segundos, luego mantenga la tapa abierta y espere 10 segundos antes de quitar los auriculares. <br/>
      NOTA: En caso de que haya un error de conexión en sus dispositivos, elimine todos los registros históricos de [TOZO Golden X1] e intente el proceso de emparejamiento nuevamente.
      `
    },
    
    {
      know_id:6,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      browse: '',
      give: '',
      title: 'Español¿Cómo reiniciar el TOZO T6 (edición clásica)?',
      description: `
      (1) Antes de reiniciar, elimine/olvide todos los TOZO en Bluetooth y desactive también la función Bluetooth. <br/>
      (2) Presione el panel de los auriculares durante 5 segundos para apagar (la luz roja parpadea) el dispositivo. <br/>
      (3) Segundos después, toque y mantenga presionados ambos auriculares durante 5 segundos hasta que las luces roja/azul parpadeen simultáneamente. Luego, toque ambos auriculares tres veces rápidamente, una vez que la luz violeta parpadee, se completará el reinicio. <br/>
      (4) Por último, encienda el BT y vuelva a conectarlo.
      `
    },
    
    {
      know_id:7,
      productId: 'TOZO_T6_Mini',
      productName: 'TOZO T6 Mini',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar el TOZO T6 (edición clásica)?',
      description: `
      (1) Antes de reiniciar, elimine/olvide todos los TOZO en Bluetooth y desactive también la función Bluetooth. <br/>
      (2) Presione el panel de los auriculares durante 5 segundos para apagar (la luz roja parpadea) el dispositivo. <br/>
      (3) Segundos después, toque y mantenga presionados ambos auriculares durante 5 segundos hasta que las luces roja/azul parpadeen simultáneamente. Luego, toca rápidamente ambos auriculares tres veces. Una vez que la luz violeta parpadee, el reinicio estará completo. <br/>
      (4) Por último, enciende el Bluetooth y vuelve a conectarlo.
      `
    },
    
    {
      know_id:8,
      productId: 'TOZO_T9',
      productName: 'TOZO T9',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar el TOZO T9?',
      description: `
      1. Elimina todos los registros de Bluetooth del [TOZO-T9] en tu dispositivo y desactiva la función Bluetooth. <br/>
      2. Saca ambos auriculares del estuche de carga, luego mantén presionados ambos auriculares durante 5 segundos hasta que la luz blanca parpadee, los dos auriculares se apagarán. <br/>
      3. Segundos después, mantén presionados ambos auriculares nuevamente durante 5 segundos, la luz blanca se encenderá por un tiempo. Una vez que la luz blanca desaparezca, toca rápidamente los auriculares dos veces. Si solo un auricular parpadea con frecuencia, el reinicio estará completo. <br/>
      4. Vuelve a colocar los auriculares en el estuche de carga y sácalos nuevamente, luego vuelve a conectarlos a tu dispositivo. <br/>
      Nota: Si tu dispositivo muestra [Error de conexión]. Elimine todos los registros de Bluetooth [TOZO-T9] en todos los dispositivos antes de emparejarlos.<br/>
      `
    },
    
    {
      know_id:9,
      productId: 'TOZO_T10',
      productName: 'TOZO T10',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar el TOZO T10 (edición clásica)?',
      description: `
      (1) Antes de reiniciar, elimine/olvide todos los TOZO en Bluetooth y desactive también la función Bluetooth. <br/>
      (2) Presione el panel de los auriculares durante 5 segundos para apagar (la luz roja parpadea) el dispositivo. <br/>
      (3) Segundos después, toque y mantenga presionados ambos auriculares durante 5 segundos hasta que las luces roja/azul parpadeen simultáneamente. Luego, toque ambos auriculares dos veces rápidamente; una vez que la luz violeta parpadee, se completará el reinicio. <br/>
      (4) Por último, encienda el Bluetooth y vuelva a conectarlo. <br/>
      `
    },
    
    {
      know_id:10,
      productId: 'TOZO_T10_Mini',
      productName: 'TOZO T10 mini',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar el TOZO T10 (edición ergonómica con aplicación (2024))?',
      description: `
      1. Elimine todos los registros de Bluetooth [TOZO T10] en el teléfono y luego apague el Bluetooth. <br/>
      2. Saque dos auriculares del estuche de carga y luego haga clic en ambos auriculares dos veces rápidamente. <br/>
      3. El reinicio se realizará cuando la luz azul parpadee rápidamente y luego la luz roja y azul de uno de los auriculares parpadee alternativamente. <br/>
      NOTA: En caso de que la conexión no sea exitosa en sus dispositivos, elimine todos los registros históricos de [TOZO T10] e intente el proceso de emparejamiento nuevamente. <br/>
      `
    },
    
    {
      know_id:11,
      productId: 'TOZO_T12',
      productName: 'TOZO T12',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar TOZO T12?',
      description: `
      (1) Antes de reiniciar, elimine/olvide todos los TOZO en Bluetooth y desactive también la función Bluetooth. <br/>
      (2) Presione el panel de los auriculares durante 5 segundos para apagar (la luz roja parpadea) el dispositivo. <br/>
      (3) Segundos después, toque y mantenga presionados ambos auriculares durante 5 segundos hasta que las luces roja/azul parpadeen simultáneamente. Luego, toque ambos auriculares tres veces rápidamente; una vez que la luz violeta parpadee, se completará el reinicio. <br/>
      (4) Por último, encienda el Bluetooth y vuelva a conectarlo. <br/>
      Reinicie los auriculares sacándolos del estuche de carga y conéctelos a [TOZO T12]. <br/>
      `
    },
    
    {
      know_id:12,
      productId: 'TOZO_T12_Pro',
      productName: 'TOZO T12 Pro',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar el TOZO T12 Pro?',
      description: `
      1. En primer lugar, elimine/olvide ambos registros de Bluetooth de [TOZO-T12 Pro] en su teléfono y luego apague el Bluetooth. <br/>
      2. Restablezca cada uno de ellos por separado con el método que se indica a continuación. No los restablezca juntos. <br/>
      (1) Mantenga presionado el botón táctil del auricular durante aproximadamente 5 segundos hasta que la luz roja se encienda durante un segundo y se apague. <br/>
      (2) Segundos después, mantenga presionado el botón táctil del auricular durante 5 segundos. Cuando las luces roja y azul parpadeen simultáneamente, tóquelo rápidamente 3 veces. <br/>
      (3) Cuando la luz violeta parpadee durante 1 segundo, se completará el proceso de reinicio de un auricular. Luego, siga este método nuevamente para reiniciar otro auricular. <br/>
      3. Después del reinicio, vuelva a colocarlos en el estuche de carga y cierre la tapa. Luego, sáquelos del estuche y déjelos así durante 30 segundos. <br/>
      4. Por último, enciende el bluetooth de tu teléfono y vuelve a conectar [TOZO T12 Pro].
      `
    },
    
    {
      know_id:13,
      productId: 'TOZO_T20',
      productName: 'TOZO T20',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar TOZO T20?',
      description: `
      Cuando los auriculares estén en el estuche de carga, mantén presionado el área de detección L y R durante 6 segundos para reiniciar.
      `
    },
    
    {
      know_id:14,
      productId: 'TOZO_T21',
      productName: 'TOZO T21',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar TOZO T21?',
      description: `
      1. Apaga el bluetooth del dispositivo. Coloca ambos auriculares en el estuche de carga y cierra la funda durante unos segundos. <br/>
      2. Sácalos del estuche de carga y la luz indicadora blanca de los auriculares parpadeará lentamente. Luego, haz doble clic en el panel táctil de ambos lados al mismo tiempo y la luz indicadora parpadeará rápidamente durante unos 3 segundos y luego parpadeará lentamente, lo que indica que el reinicio se completó. Luego, enciende el bluetooth del dispositivo y vuelve a conectar los auriculares. <br/>
      3. Si la falla persiste, realiza los pasos anteriores nuevamente. <br/>
      ¿Cómo reiniciar TOZO NC2?
      Si por accidente solo funciona un auricular o no se pueden emparejar entre sí, reinícielo: <br/>
      Coloque los auriculares en el estuche de carga, abra la tapa y mantenga presionado el botón del estuche durante 15 segundos. <br/>
      NOTA: En caso de que haya un error de conexión en sus dispositivos, elimine todos los registros históricos de [TOZO-NC2] e intente el proceso de emparejamiento nuevamente. <br/>
      Después del reinicio: <br/>
      Abra el estuche de carga, mantenga los auriculares en el estuche de carga y mantenga presionado el botón del estuche de carga durante 3 segundos para forzar a los auriculares a ingresar al estado de emparejamiento. Tenga en cuenta que esta operación no borrará el registro de emparejamiento Bluetooth anterior. <br/>
      `
    },
    
    {
      know_id:15,
      productId: 'TOZO_NC2',
      productName: 'TOZO NC2',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar el TOZO NC2?',
      description: `
      Si por accidente solo funciona un auricular o no se emparejan entre sí, reinícielo: <br/>
      Coloque los auriculares en el estuche de carga, abra la tapa, mantenga presionado el botón del estuche durante 15 segundos. <br/>
      NOTA: En caso de que haya un error de conexión en sus dispositivos, elimine todos los registros históricos de [TOZO-NC2] e intente el proceso de emparejamiento nuevamente. <br/>
      Después del reinicio: <br/>
      Abra el estuche de carga, mantenga los auriculares en el estuche de carga, mantenga presionado el botón del estuche de carga durante 3 segundos para forzar a los auriculares a ingresar al estado de emparejamiento. Tenga en cuenta que esta operación no borrará el registro de emparejamiento Bluetooth anterior. <br/>
      `
    },
    
    {
      know_id:16,
      productId: 'TOZO_NC7',
      productName: 'TOZO NC7',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar el TOZO NC7?',
      description: `
      1. Elimine todos los registros de Bluetooth de [TOZO-NC7] en el teléfono, luego apague la función Bluetooth. <br/>
      2. Saque ambos auriculares del estuche de carga, mantenga presionado el botón táctil en ambos auriculares durante 5 segundos hasta que la luz roja se encienda durante un segundo y se apague. <br/>
      3. Segundos después, mantenga presionado el botón táctil en ambos auriculares durante 5 segundos. Una vez que la luz azul se encienda y se apague, toque los botones dos veces rápidamente, luego los dos auriculares parpadearán con luz azul con frecuencia y, finalmente, la luz violeta se encenderá durante aproximadamente un segundo, lo que indica que el restablecimiento se completó.
      Nota: Si su dispositivo muestra [Error de conexión]. Elimine todos los registros de Bluetooth de [TOZO-NC7] en todos los dispositivos antes de emparejarlos. <br/>
      `
    },
    
    {
      know_id:17,
      productId: 'TOZO_NC9',
      productName: 'TOZO NC9',
      browse: '',
      give: '',
      title: '¿Cómo restablecer TOZO NC9?',
      description: `
      1. Elimine todos los registros de Bluetooth de TOZO-NC9 en el teléfono, luego apague el Bluetooth. <br/>
      2. Mantenga presionados los botones táctiles de ambos auriculares durante aproximadamente 5 segundos hasta que la luz roja se encienda durante un segundo y se apague. <br/>
      3. Segundos después, mantenga presionados los botones táctiles de dos auriculares durante 5 segundos. Cuando la luz azul del auricular se encienda y apague, presione rápidamente los dos botones táctiles 2 o 3 veces. <br/>
      4. Cuando la luz roja parpadee durante 1 segundo, se completará el proceso de reinicio. Luego, vuelva a colocarlos en el estuche de carga, sáquelos nuevamente y conéctelos a su dispositivo. <br/>
      Nota: En caso de que haya un error de conexión en su dispositivo, elimine todos los registros históricos de [TOZO-NC9] e intente el proceso de emparejamiento nuevamente. <br/>
      `
    },
    
    {
      know_id:18,
      productId: 'TOZO_NC9_Plus',
      productName: 'TOZO NC9 Plus',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar el TOZO NC9 Plus?',
      description: `
      1. Borra todos los registros de Bluetooth del TOZO-NC9 Plus en el teléfono y luego apaga el Bluetooth. <br/>
      2. Mantén presionados los botones táctiles de ambos auriculares durante aproximadamente 5 segundos hasta que la luz roja se encienda durante un segundo y se apague. <br/>
      3. Segundos después, mantén presionados los botones táctiles de los dos auriculares durante 5 segundos. Cuando la luz azul del auricular se encienda y se apague, haz clic rápidamente en ambos botones táctiles 2 o 3 veces. <br/>
      4. Cuando la luz roja parpadee durante 1 segundo, se completará el proceso de reinicio. Luego, vuelve a colocarlos en el estuche de carga, sácalos nuevamente y conéctalos a tu dispositivo. <br/>
      Nota: En caso de que haya un error de conexión en tu dispositivo, borra todos los registros históricos de [TOZO-NC9 Plus] e intenta el proceso de emparejamiento nuevamente. <br/>
      `
    },
    
    {
      know_id:19,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar el TOZO A1?',
      description: `
      1. Elimine/olvide los registros de [TOZO-A1] en su dispositivo y luego apague la función Bluetooth. <br/>
      2. Saque ambos auriculares del estuche de carga y luego toque rápidamente los dos botones táctiles 5 veces. El reinicio se completará cuando la luz roja parpadee durante un segundo. <br/>
      3. Vuelva a colocar los auriculares en el estuche y cierre la tapa. Luego, sáquelos nuevamente y vuelva a conectarlos a su dispositivo. <br/>
      Nota: Si su dispositivo muestra [Error de conexión]. Elimine todos los registros de Bluetooth de [TOZO-A1] en todos los dispositivos antes de emparejarlos. <br/>
      `
    },
    
    {
      know_id:20,
      productId: 'TOZO_A2',
      productName: 'TOZO A2',
      browse: '',
      give: '',
      title: '¿Cómo restablecer TOZO A2?',
      description: `
      1. Elimine todos los registros de Bluetooth de [TOZO-A2] en su dispositivo y luego apague la función Bluetooth. <br/>
      2. Saque los dos auriculares del estuche de carga y colóquelos. A continuación, mantenga presionados ambos auriculares durante unos 5 segundos y suelte los dedos después de escuchar "Apagado". <br/>
      3. Vuelva a mantener presionados ambos auriculares durante unos 8 segundos y suelte los dedos después de escuchar "Emparejamiento PTP". El reinicio estará completo. <br/>
      4. Coloque los auriculares en el estuche y sáquelos de nuevo. Los dos auriculares parpadearán en rojo y azul alternativamente. Encienda el Bluetooth para conectar los auriculares. <br/>
      `
    },
    
    {
      know_id:21,
      productId: 'TOZO_A3',
      productName: 'TOZO A3',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar los TOZO A3?',
      description: `
      Coloca ambos auriculares en el estuche de carga, olvida/desempareja [TOZO- A3] en tu dispositivo. <br/>
      1.Abre el estuche de carga y mantén los auriculares dentro. <br/>
      2.Mantén presionado el botón del estuche de carga durante 8 segundos, la luz indicadora en el estuche parpadeará 5 veces y la luz blanca en los auriculares parpadeará rápidamente. <br/>
      3.Saca los auriculares del estuche de carga y vuelve a conectarlos con el dispositivo. <br/>
      `
    },
    
    {
      know_id:22,
      productId: 'TOZO_Crystal_Buds',
      productName: 'TOZO Crystal Buds',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar los TOZO Crystal Buds?',
      description: `
      (1) Apaga el bluetooth del teléfono móvil y borra/olvida todos los registros bluetooth de los [TOZO Crystal Buds]. <br/>
      (2) Saca los auriculares del estuche de carga, presiona el panel táctil durante 5 segundos para apagar los auriculares. <br/>
      (3) Mantén presionados ambos auriculares al mismo tiempo durante 8 segundos, suéltalos después de que la luz blanca parpadee rápidamente. El reinicio está completo. <br/>
      `
    },
    
    {
      know_id:23,
      productId: 'TOZO_G1',
      productName: 'TOZO G1',
      browse: '',
      give: '',
      title: '¿Cómo reiniciar los TOZO G1?',
      description: `
      Para restablecer la configuración de fábrica, siga los pasos que se indican a continuación: <br/>
      1. Elimine todos los registros de [TOZO-G1] en el teléfono y luego desactive también la función Bluetooth. <br/>
      2. Saque los auriculares del estuche de carga y presione rápidamente el botón táctil MFB en ambos auriculares 5 veces; luego, los auriculares se apagarán. <br/>
      3. Vuelva a colocar los auriculares en el estuche de carga y cierre la tapa. Luego, vuelva a sacar los auriculares. Cuando la luz de respiración de un auricular se encienda y el otro esté parpadeando, el proceso de reinicio estará completo. <br/>
      `
    },
    
    {
      know_id:24,
      productId: 'TOZO_H10',
      productName: 'TOZO H10',
      browse: '',
      give: '',
      title: '¿Cómo restablecer el TOZO H10?',
      description: `
      Restaurar la configuración de fábrica Cuando el auricular esté encendido. Mantenga presionadas las teclas más y menos simultáneamente durante 8 segundos para restaurar la configuración de fábrica
      `
    },
    
    {
      know_id:25,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      browse: '',
      give: '',
      title: 'La pantalla no se ilumina al levantar la muñeca.',
      description: `
      Verifique la configuración del reloj: asegúrese de que la función Levantar para activar esté habilitada en el reloj. <br/>
      Verifique la configuración de la aplicación: confirme que la función Levantar para activar también esté habilitada en la aplicación complementaria. <br/>
      Verifique la configuración del tiempo activo: asegúrese de que la hora actual esté dentro del período de pantalla activa establecido en la aplicación. De manera predeterminada, el tiempo de pantalla activa se establece de 8:00 a. m. a 8:00 p. m. Si el usuario necesita ajustar este rango de tiempo, puede hacerlo dentro de la aplicación. <br/>
      `
    },
    
    {
      know_id:26,
      productId: 'Watches',
      productName: 'Watches',
      browse: '',
      give: '',
      title: 'El reloj inteligente puede recibir mensajes, pero no puede realizar ni recibir llamadas',
      description: `
      Asegúrese de la conexión de la aplicación: <br/> <br/>

      Verifique que la aplicación complementaria esté conectada correctamente al reloj inteligente. <br/>
      Verifique la configuración de Bluetooth del sistema: <br/> <br/>

      Vaya a la configuración de Bluetooth en su dispositivo e ingrese los detalles del dispositivo. Si la pantalla se parece a la "Figura 2", indica que la conexión Bluetooth relacionada con la llamada no está establecida. <br/>
      Toque "Olvidar este dispositivo" para eliminar el dispositivo de la lista de Bluetooth. <br/>
      Vuelva a conectar Bluetooth a través de la aplicación: <br/> <br/>

      Regrese a la aplicación complementaria. Debería recibir un mensaje para volver a conectar Bluetooth. <br/>
      Toque el botón "Configurar", que lo llevará automáticamente a la página de configuración de Bluetooth del sistema. Confirme la conexión. Verifique la conexión: <br/> <br/>

      Vuelva a ingresar los detalles del dispositivo en la configuración de Bluetooth. Si la pantalla ahora se parece a la "Figura 4", la conexión Bluetooth relacionada con la llamada se realizó correctamente. <br/>
      Si no se establece la conexión, repita los pasos anteriores hasta que aparezca la pantalla que se parece a la "Figura 4".
      `
    },
  ]

  //热门说明书资源
  let hot_manualsList = [
    {
      id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title:'TOZO Golden X1 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}X1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}X1.pdf`,
    },
    {
      id:2,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title:'TOZO Golden X1 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}X1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}X1.pdf`,
    },

    {
      id:3,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title:'TOZO HT2 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}HT2.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}HT2.pdf`,
    },
    {
      id:4,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title:'TOZO HT2 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}HT2.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}HT2.pdf`,
    },

    {
      id:5,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      title:'TOZO Open Buds Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Buds.pdf`,
    },
    {
      id:6,
      productId: 'TOZO_Open_Buds',
      productName: 'TOZO Open Buds',
      title:'TOZO Open Buds Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Buds.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Buds.pdf`,
    },

    {
      id:7,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title:'TOZO OpenReal Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Real.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Real.pdf`,
    },
    {
      id:8,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title:'TOZO OpenReal Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Real.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Real.pdf`,
    },

    {
      id:9,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title:'TOZO OpenEgo Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}Open_Ego.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}Open_Ego.pdf`,
    },
    {
      id:10,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title:'TOZO OpenEgo Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}Open_Ego.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}Open_Ego.pdf`,
    },

    {
      id:11,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title:'TOZO T6 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}T6.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}T6.pdf`,
    },
    {
      id:12,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title:'TOZO T6 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}T6.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}T6.pdf`,
    },

    {
      id:13,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title:'TOZO A1 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}A1.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}A1.pdf`,
    },
    {
      id:14,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title:'TOZO A1 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}A1.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}A1.pdf`,
    },

    {
      id:15,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      title:'TOZO S5 Manual de usuario',
      preview_TOZO_Url: `${preview_TOZO_UserManual_Url}S5.pdf`,
      download_TOZO_Url: `${download_TOZO_UserManual_Url}S5.pdf`,
    },
    {
      id:16,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      title:'TOZO S5 Guía rápida',
      preview_TOZO_Url: `${preview_TOZO_QuickGuide_Url}S5.pdf`,
      download_TOZO_Url: `${download_TOZO_QuickGuide_Url}S5.pdf`,
    },
  ]

  //热门视频资源
  let hot_VideoTutoralList = [
    {
      id:1,
      productId: 'TOZO_Golden_X1',
      productName: 'TOZO Golden X1',
      title: 'TOZO Golden X1',
      url: `${videoHttps}X1_${language}.mp4`,
    },
    {
      id:2,
      productId: 'TOZO_HT2',
      productName: 'TOZO HT2',
      title: 'TOZO HT2',
      url: `${videoHttps}HT2_${language}.mp4`,
    },
    
    {
      id:3,
      productId: 'TOZO_OpenBuds',
      productName: 'TOZO OpenBuds',
      title: 'TOZO Open Buds',
      url: `${videoHttps}OpenBuds_${language}.mp4`,
    },
    {
      id:4,
      productId: 'TOZO_Open_Real',
      productName: 'TOZO OpenReal',
      title: 'TOZO OpenReal',
      url: `${videoHttps}Open_Real_${language}.mp4`,
    },
    {
      id:5,
      productId: 'TOZO_Open_Ego',
      productName: 'TOZO OpenEgo',
      title: 'TOZO OpenEgo',
      url: `${videoHttps}Open_Ego_${language}.mp4`,
    },
    {
      id:6,
      productId: 'TOZO_T6',
      productName: 'TOZO T6',
      title: 'TOZO T6',
      url: `${videoHttps}T6_${language}.mp4`,
    },
    {
      id:7,
      productId: 'TOZO_A1',
      productName: 'TOZO A1',
      title: 'TOZO A1',
      url: `${videoHttps}A1_${language}.mp4`,
    },
    {
      id:8,
      productId: 'TOZO_S5',
      productName: 'TOZO S5',
      title: 'TOZO S5',
      url: `${videoHttps}S5_${language}.mp4`,
    },
  ]

  //自定义的本地数据分页
  function customPaginateData(data, page, perPage) {
    // 确保页数和每页条数是有效的
    page = Math.max(1, page);
    perPage = Math.max(1, perPage);
  
    // 计算总记录数
    const total = data.length;
  
    // 计算总页数
    const lastPage = Math.ceil(total / perPage);
  
    // 计算当前页的开始和结束索引
    const start = (page - 1) * perPage;
    const end = Math.min(start + perPage, total);
  
    // 获取当前页的数据
    const currentPageData = data.slice(start, end);
  
    return {
      current_page: page,
      last_page: lastPage,
      per_page: perPage,
      to: end,
      total: total,
      data: currentPageData
    };
  }